<template>
    <div>
        <div class="pg-head">
            <div class="pg-ico"><span class="mdi mdi-account-group"></span></div>
            <div><div class="id-h1">{{ $t('gymnasts.listTitle') }}</div></div>
        </div>
        <!-- แท็บในหน้า (ไม่ใช่เมนูใหม่ — จึงไม่แตะไซด์บาร์/MENU_SCROPE.md) -->
        <div class="pg-tabs">
            <button class="pg-tab" :class="{ on: tab === 'list' }" @click="tab = 'list'">
                <span class="mdi mdi-account-group"></span> {{ $t('dup.tabList') }}
            </button>
            <button class="pg-tab" :class="{ on: tab === 'unclaimed' }" @click="switchToUnclaimed">
                <span class="mdi mdi-account-question-outline"></span> {{ $t('dup.tabUnclaimed') }}
                <span v-if="unclaimedCounts.total" class="pg-tab-badge">{{ unclaimedCounts.total }}</span>
            </button>
        </div>

        <!-- มาตรฐาน DataGrid: toolbar แถวเดียว [ค้นหา] -> (ดันขวา) [รีเฟรช][เพิ่ม] -->
        <div class="grid-toolbar" v-show="tab === 'list'">
            <label class="grid-search"><span class="mdi mdi-magnify"></span>
                <input class="id-input" v-model="search" :placeholder="$t('btn.search')" /></label>
            <id-select class="grid-filter" v-model="filterStatus" :placeholder="$t('gymnasts.filterStatus')"
                :options="[
                    { value: '', label: $t('gymnasts.statusAll') },
                    { value: 'active', label: $t('gymnasts.statusActive') },
                    { value: 'nocourse', label: $t('gymnasts.statusNoCourse') }]"
                @update:model-value="applyFilter"></id-select>
            <id-select class="grid-filter" v-model="filterGender" :placeholder="$t('gymnasts.filterGender')"
                :options="[
                    { value: '', label: $t('gymnasts.genderAll') },
                    { value: 'ชาย', label: $t('common.male') },
                    { value: 'หญิง', label: $t('common.female') }]"
                @update:model-value="applyFilter"></id-select>
            <id-select class="grid-filter" v-model="filterCourse" searchable :placeholder="$t('gymnasts.filterCourse')"
                :options="courseFilterOptions" @update:model-value="applyFilter"></id-select>
            <span class="grid-spacer"></span>
            <button class="id-btn id-btn-ghost id-btn-sm" @click="initialize"><span class="mdi mdi-refresh"></span> {{ $t('btn.refresh') }}</button>
            <button class="id-btn id-btn-primary id-btn-sm" @click="showAddNewStudent"><span class="mdi mdi-emoticon-plus-outline"></span> {{ $t('gymnasts.addStudent') }}</button>
        </div>
        <!-- ตาราง .idt: วนหัวจาก StudentListHeaders เดิม (i18n ถูกอัตโนมัติ) -->
        <div class="scard" style="padding:14px" v-show="tab === 'list'">
            <div style="overflow-x:auto">
                <table class="idt">
                    <thead><tr><th v-for="h in StudentListHeaders" :key="h.key"
                        :class="[h.class, { 'idt-sortable': h.sortable !== false, 'idt-sorted': $sortDir(tableOptions.sortBy, h.key) }]"
                        :style="{ textAlign: (h.align==='center'||h.align==='end') ? 'center' : 'left' }" @click="applySort(h)">
                        {{ h.title }}
                        <span v-if="$sortDir(tableOptions.sortBy, h.key)" class="mdi idt-sort-ico" :class="$sortDir(tableOptions.sortBy, h.key) === 'desc' ? 'mdi-arrow-down' : 'mdi-arrow-up'"></span>
                    </th></tr></thead>
                    <tbody v-if="loadingStudent" class="id-fade-in" key="sk">
                        <tr v-for="i in 6" :key="'sk' + i">
                            <td v-for="h in StudentListHeaders" :key="h.key" :class="h.class"><div class="id-skel" style="height:18px"></div></td>
                        </tr>
                    </tbody>
                    <tbody v-else class="id-fade-in" :key="tableOptions.page">
                        <tr v-for="item in StudentList" :key="item.studentid">
                            <td v-for="h in StudentListHeaders" :key="h.key" :class="h.class" :style="{ textAlign: (h.align==='center'||h.align==='end') ? 'center' : 'left' }">
                                <template v-if="h.key==='fullname'">{{ item.fullname }}</template>
                                <template v-else-if="h.key==='dateofbirth'">{{ calculateAge(item.dateofbirth).int }}</template>
                                <template v-else-if="h.key==='expiredate'"><span :class="{ 'highlighted-red': item.expiredate != null && isExpiredDate(item.expiredate) }">{{ expireDateLeft(item.expiredate) }}</span></template>
                                <!-- ปุ่มลูกตา = ดูข้อมูล + ประวัติการเรียนแบบอ่านอย่างเดียว (ไม่ใช่ dialog แก้ไข) -->
                                <template v-else-if="h.key==='view'"><span class="mdi mdi-eye" style="color:var(--c-info);cursor:pointer;font-size:20px" @click="clickViewStudent(item)"></span></template>
                                <template v-else-if="h.key==='edit'"><span class="mdi mdi-pencil" style="color:var(--c-info);cursor:pointer;font-size:20px" @click="clickEditStudent(item)"></span></template>
                                <!-- ปุ่มประวัติการแก้ไข (อ่านอย่างเดียว) — ไทม์ไลน์ "ใครแก้อะไรเมื่อไหร่" จาก taction_log -->
                                <template v-else-if="h.key==='history'"><span class="mdi mdi-history" style="color:var(--c-primary);cursor:pointer;font-size:20px" @click="showStudentHistory(item)"></span></template>
                                <template v-else-if="h.key==='delete'"><span class="mdi mdi-delete-forever" style="color:var(--c-error);cursor:pointer;font-size:20px" @click="clickDeleteStudent(item)"></span></template>
                                <template v-else>{{ item[h.key] }}</template>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-if="!loadingStudent && StudentList.length===0" class="grid-empty"><span class="mdi mdi-account-off-outline"></span>{{ $t('common.noStudentList') }}</div>
            <!-- footer: server pagination เดิม (tableOptions + totalStudents) -->
            <id-grid-footer v-if="totalStudents > 0"
                :page="tableOptions.page"
                :page-count="Math.max(1, Math.ceil(totalStudents / tableOptions.itemsPerPage))"
                :per-page="tableOptions.itemsPerPage" :total="totalStudents"
                @update:page="(p) => { tableOptions.page = p; getStudentList(currentActive, true); }"
                @update:per-page="(n) => { tableOptions.itemsPerPage = n; tableOptions.page = 1; getStudentList(currentActive, true); }" />
        </div>

        <!-- ===== แท็บ "ยังไม่มีผู้ปกครอง" — คิวงาน ไม่ใช่ข้อมูลเสีย =====
             คอลัมน์ "ตัวจริงในระบบ" มาพร้อมข้อมูลตั้งแต่โหลด (backend หาให้ใน query เดียว 41ms)
             จึงไม่มีปุ่มให้กดทีละแถวอีก — แถวไม่เปลี่ยนความสูง และ sort ได้เหมือนคอลัมน์อื่น -->
        <div v-show="tab === 'unclaimed'">
            <div class="unc-hint"><span class="mdi mdi-information-outline"></span> {{ $t('dup.unclaimedHint') }}</div>
            <div class="unc-stats">
                <div class="unc-stat"><b>{{ unclaimedCounts.total }}</b><span>{{ $t('dup.statTotal') }}</span></div>
                <button type="button" class="unc-stat is-act" :class="{ on: unclaimedFilter === 'matched' }"
                    @click="toggleUncFilter('matched')"><b>{{ unclaimedCounts.withMatch }}</b><span>{{ $t('dup.statWithMatch') }}</span></button>
                <div class="unc-stat"><b>{{ unclaimedCounts.withBookings }}</b><span>{{ $t('dup.statWithBookings') }}</span></div>
                <div class="unc-stat"><b>{{ unclaimedCounts.withCourse }}</b><span>{{ $t('dup.statWithCourse') }}</span></div>
                <div class="unc-stat"><b>{{ unclaimedCounts.noFamily }}</b><span>{{ $t('dup.statNoFamily') }}</span></div>
            </div>
            <div class="grid-toolbar">
                <label class="grid-search"><span class="mdi mdi-magnify"></span>
                    <input class="id-input" v-model="unclaimedSearch" autocomplete="off" name="unc-q" :placeholder="$t('btn.search')" /></label>
                <id-select class="grid-filter" v-model="unclaimedFilter" :placeholder="$t('dup.filterAll')"
                    :options="[
                        { value: '', label: $t('dup.filterAll') },
                        { value: 'matched', label: $t('dup.filterMatched') },
                        { value: 'unmatched', label: $t('dup.filterUnmatched') }]"
                    @update:model-value="unclaimedPage = 1"></id-select>
                <span class="grid-spacer"></span>
                <button class="id-btn id-btn-ghost id-btn-sm" @click="loadUnclaimed(true)"><span class="mdi mdi-refresh"></span> {{ $t('btn.refresh') }}</button>
            </div>
            <div class="scard" style="padding:14px">
                <div style="overflow-x:auto">
                    <table class="idt">
                        <thead><tr>
                            <th v-for="h in unclaimedHeaders" :key="h.key"
                                :class="[h.class, { 'idt-sortable': h.key !== 'action', 'idt-sorted': $sortDir(unclaimedSort, h.key) }]"
                                :style="{ textAlign: h.align === 'center' ? 'center' : 'left' }"
                                @click="h.key !== 'action' && (unclaimedSort = $toggleSort(unclaimedSort, h.key))">
                                {{ h.title }}
                                <span v-if="$sortDir(unclaimedSort, h.key)" class="mdi idt-sort-ico"
                                    :class="$sortDir(unclaimedSort, h.key) === 'desc' ? 'mdi-arrow-down' : 'mdi-arrow-up'"></span>
                            </th>
                        </tr></thead>
                        <tbody v-if="loadingUnclaimed || unclaimedPaging" class="id-fade-in" key="usk">
                            <tr v-for="i in 6" :key="'usk' + i"><td v-for="j in unclaimedHeaders.length" :key="j"><div class="id-skel" style="height:18px"></div></td></tr>
                        </tbody>
                        <tbody v-else class="id-fade-in" :key="'up' + unclaimedPage + unclaimedSortKey">
                            <tr v-for="row in pagedUnclaimed" :key="row.studentid">
                                <td>{{ row.fullname }}<span v-if="row.nickname" class="unc-nick">({{ row.nickname }})</span></td>
                                <td><span v-if="row.family_username">{{ row.family_username }}</span>
                                    <span v-else class="unc-nofam">{{ $t('dup.noFamily') }}</span></td>
                                <td>{{ $formatShortDate(row.createdate) }}</td>
                                <td style="text-align:center">{{ row.bookings }}</td>
                                <td>{{ row.lastclassdate ? $formatShortDate(row.lastclassdate) : '—' }}</td>
                                <td>{{ row.courserefer || '—' }}</td>
                                <!-- ⚠️ ทั้งสองสถานะเป็น "ข้อความ + ชิป" ความสูงเท่ากัน ไม่มีปุ่มมาดันแถวให้สูงขึ้น -->
                                <td>
                                    <span v-if="!row.matches.length" class="unc-nomatch">—</span>
                                    <span v-else class="unc-dup" :class="{ weak: !row.needMerge }">
                                        <span class="mdi mdi-content-duplicate"></span>
                                        {{ row.matches[0].fullname }}<template v-if="row.matches.length > 1"> +{{ row.matches.length - 1 }}</template>
                                    </span>
                                </td>
                                <td class="idt-action">
                                    <!-- ปุ่มเดียวต่อแถว ขนาดคงที่ทั้งสองสถานะ (แถวจึงไม่ขยับ) และโฟกัสด้วยคีย์บอร์ดได้
                                         needMerge = ซ้ำของจริง ย้ายไม่ได้ ต้องรวมประวัติ
                                         ไม่ใช่ = ย้ายเข้าครอบครัวได้ (รวมเคสฝาแฝด/วันเกิดตัวยืนที่แค่ชื่อพ้อง) -->
                                    <button v-if="row.needMerge" class="unc-act warn" v-hint="$t('dup.needMergeHint')"
                                        :aria-label="$t('dup.needMergeHint')" @click="openMergeInfo(row)">
                                        <span class="mdi mdi-alert-circle-outline"></span></button>
                                    <button v-else class="unc-act" v-hint="$t('dup.assignFamily')"
                                        :aria-label="$t('dup.assignFamily')" @click="openAssign(row)">
                                        <span class="mdi mdi-home-plus-outline"></span></button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="!loadingUnclaimed && !unclaimedPaging && filteredUnclaimed.length === 0" class="grid-empty">
                    <span class="mdi mdi-account-off-outline"></span>{{ $t('common.noStudentList') }}</div>
                <id-grid-footer v-if="filteredUnclaimed.length > 0"
                    :page="unclaimedPage" :page-count="Math.max(1, Math.ceil(filteredUnclaimed.length / unclaimedPerPage))"
                    :per-page="unclaimedPerPage" :total="filteredUnclaimed.length"
                    @update:page="(p) => runUnclaimedPaging(() => { unclaimedPage = p; })"
                    @update:per-page="(n) => runUnclaimedPaging(() => { unclaimedPerPage = n; unclaimedPage = 1; })" />
            </div>
        </div>


        <!-- ===== ไดอะล็อกเดิมทั้งหมด คงไว้ ไม่แตะ logic (เปิดด้วยปุ่ม showAddNewStudent / clickEditStudent) ===== -->
        <id-modal v-model="dialogStudent" size="xl" persistent
                  :icon="editedStudentIndex == -1 ? 'mdi-emoticon-plus-outline' : 'mdi-human-edit'"
                  :title="formStudentTitle">
            <v-form ref="newstdform">
                <div class="dlg-avatar" style="margin-bottom:20px">
                    <div class="av-ph" @click="triggerFileInput">
                        <img v-if="imagePreview" :src="imagePreview" />
                        <span v-else class="mdi mdi-account"></span>
                    </div>
                    <label class="av-cam"><span class="mdi mdi-camera"></span>
                        <input type="file" accept="image/*" hidden ref="fileInput" @change="onFileChange"></label>
                </div>

                <div class="modal-sec"><span class="mdi mdi-card-account-details-outline"></span> {{ $t('table.studentInfo') }}</div>
                <div class="form-grid-3">
                    <div class="field"><label>{{ $t('table.firstname') }} <span class="req">*</span></label><input class="id-input" v-model="editedStudentItem.firstname"></div>
                    <div class="field"><label>{{ $t('table.middlename') }}</label><input class="id-input" v-model="editedStudentItem.middlename"></div>
                    <div class="field"><label>{{ $t('table.lastname') }} <span class="req">*</span></label><input class="id-input" v-model="editedStudentItem.lastname"></div>
                </div>
                <div class="form-grid-4" style="margin-top:14px">
                    <div class="field"><label>{{ $t('table.nickname') }} <span class="req">*</span></label><input class="id-input" v-model="editedStudentItem.nickname"></div>
                    <div class="field"><label>{{ $t('table.gender') }}</label>
                        <id-select v-model="editedStudentItem.gender" :placeholder="$t('common.select')"
                            :options="[{ value: 'ชาย', label: $t('common.male') }, { value: 'หญิง', label: $t('common.female') }]"></id-select></div>
                    <div class="field"><label>{{ $t('table.dob') }}</label>
                        <id-date v-model="editedStudentItem.dateofbirth" :placeholder="$t('common.selectDob')" @update:model-value="calculateAgeNewStudent"></id-date></div>
                    <div class="field"><label>{{ $t('table.age') }}</label><input class="id-input" :value="editedStudentItem.age" readonly></div>
                </div>
                <div class="form-grid" style="margin-top:14px">
                    <div class="field"><label>{{ $t('table.level') }}</label><input class="id-input" type="number" v-model="editedStudentItem.level"></div>
                    <div class="field"><label>{{ $t('table.parentUsername') }} <span class="req">*</span></label>
                        <id-select v-model="editedStudentItem.familyid" searchable :placeholder="$t('common.select')" :search-placeholder="$t('gymnasts.typeUsername')"
                            :options="familyLookup.map(f => ({ value: f.familyid, label: f.username }))"></id-select></div>
                    <div class="field full"><label>{{ $t('table.shortNote') }}</label><textarea class="id-input id-textarea" v-model="editedStudentItem.shortnote"></textarea></div>
                </div>
                <div class="course-flow" style="margin-top:14px">
                    <div class="field" style="flex:1"><label>{{ $t('table.courseRefer') }}</label>
                        <id-select v-model="editedStudentItem.courserefer" searchable :placeholder="$t('common.select')"
                            :options="customerCourseLookup.map(c => ({ value: c.courserefer, label: c.courserefer }))"
                            @update:model-value="onCourseChange"></id-select>
                        <!-- คำอธิบายใต้ช่อง (ไม่ใช่ในดร็อปดาวน์ — เจ้าของเคาะ) บอกว่าแพ็กเกจที่เลือกมีใครใช้อยู่แล้ว -->
                        <div v-if="courseDesc1" class="field-desc" :class="courseDesc1.level">
                            <span class="mdi" :class="courseDesc1.icon"></span> {{ courseDesc1.text }}
                        </div></div>
                    <div class="flow-arrow">{{ $t('common.nextCourse') }}<span class="mdi mdi-arrow-right"></span></div>
                    <div class="field" style="flex:1"><label>{{ $t('table.continueCourseRefer') }}</label>
                        <id-select v-model="editedStudentItem.courserefer2" searchable :placeholder="$t('common.select')"
                            :options="customerCourseLookup.map(c => ({ value: c.courserefer, label: c.courserefer }))"></id-select>
                        <div v-if="courseDesc2" class="field-desc" :class="courseDesc2.level">
                            <span class="mdi" :class="courseDesc2.icon"></span> {{ courseDesc2.text }}
                        </div></div>
                    <button v-if="editedStudentIndex != -1" type="button" class="id-btn id-btn-ghost" style="flex:0 0 auto" @click="finishCourse()">
                        <span class="mdi mdi-check-circle"></span> {{ $t('table.finish') }}</button>
                </div>

                <div class="modal-sec mt"><span class="mdi mdi-history"></span> {{ $t('table.courseUsageHistory') }}</div>
                <!-- แทนบรรทัด current_course_detail เดิม — แยก "ถืออยู่ตอนนี้" กับ "เคยใช้" -->
                <course-holders-line :holders="courseHolders" :ever-used="courseEverUsed" />
                <div class="id-modal-grid"><div class="id-modal-grid-scroll" style="max-height:30vh">
                    <v-data-table :headers="CourseUsingHeaders" :items="CourseUsingtList" density="compact" :items-per-page="100">
                        <template v-slot:item.index="{ item }">{{ CourseUsingtList.indexOf(item) + 1 }}</template>
                        <template v-slot:item.classdate="{ item }"><p>{{ format_date(item.classdate) }} </p></template>
                        <template v-slot:item.createby="{ item }"><booked-by-cell :name="item.createby" :role="item.createby_role" :at="item.createdate" /></template>
                        <template v-slot:item.lastedit_by="{ item }"><booked-by-cell :name="item.lastedit_by" :role="item.lastedit_role" :at="item.lastedit_at" /></template>
                        <template #bottom></template>
                    </v-data-table>
                </div></div>
            </v-form>
            <template #footer>
                <button class="id-btn id-btn-ghost" @click="closeStudent">{{ $t('btn.cancel') }}</button>
                <button class="id-btn id-btn-primary" :disabled="!editedStudentItem.firstname || !editedStudentItem.lastname || !editedStudentItem.nickname" @click="doSaveNewStudent">
                    <span class="mdi mdi-content-save"></span> {{ $t('btn.save') }}</button>
            </template>
        </id-modal>

        <id-modal v-model="dialogFinish" size="sm" icon="mdi-check-decagram-outline" :title="$t('table.finish')" persistent>
            <p style="margin:0">{{ $t('gymnasts.confirmFinish') }}</p>
            <template #footer>
                <button class="id-btn id-btn-ghost" @click="closeFinish">{{ $t('btn.cancel') }}</button>
                <button class="id-btn id-btn-primary" @click="finishCourseConfirm"><span class="mdi mdi-check"></span> {{ $t('btn.confirm') }}</button>
            </template>
        </id-modal>

        <id-modal v-model="dialogStudentDelete" size="sm" icon="mdi-delete-alert-outline" :title="$t('common.confirmDeleteTitle')" persistent>
            <p style="margin:0">{{ $t('gymnasts.confirmDelete') }}</p>
            <template #footer>
                <button class="id-btn id-btn-ghost" @click="clickCancelDeleteStd">{{ $t('btn.cancel') }}</button>
                <button class="id-btn id-btn-primary" style="background:var(--c-error)" @click="clickConfirmDeleteStd"><span class="mdi mdi-delete"></span> {{ $t('btn.ok') }}</button>
            </template>
        </id-modal>

        <!-- ===== ดูข้อมูล + ประวัติการเรียน (read-only) — คลาสกลุ่ม + Private + เรียนฟรี + อีเวนต์ ในที่เดียว =====
             แยกจาก dialog แก้ไขด้านบนโดยเจตนา: ที่นี่ไม่มีฟอร์ม ไม่มีปุ่มบันทึก แก้ข้อมูลอะไรไม่ได้เลย -->
        <id-modal v-model="dialogStudentView" size="lg" icon="mdi-eye"
                  :title="$t('learningHistory.title')" :subtitle="viewStudent.fullname || ''">
            <!-- รูปเด็ก — ใช้ .dlg-avatar/.av-ph ชุดเดียวกับไดอะล็อกแก้ไข ต่างแค่ไม่มีปุ่มกล้อง (.av-cam)
                 เพราะจอนี้อ่านอย่างเดียว · ใช้ <img> ธรรมดาเสมอ ห้าม <v-img> (lazy ของมันรอ
                 IntersectionObserver ที่ไม่เคยมาในไดอะล็อก แล้วไม่สร้าง <img> เลย — เคยพลาดมาแล้ว) -->
            <div class="dlg-avatar" style="margin-bottom:18px">
                <div class="av-ph">
                    <img v-if="viewImageUrl" :src="viewImageUrl" :alt="viewStudent.nickname || viewStudent.fullname || ''" />
                    <span v-else class="mdi mdi-account"></span>
                </div>
            </div>
            <div class="modal-sec"><span class="mdi mdi-card-account-details-outline"></span> {{ $t('table.studentInfo') }}</div>
            <div class="info-rows">
                <div class="info-row">
                    <span class="info-label"><span class="mdi mdi-account-outline"></span> {{ $t('table.name') }}</span>
                    <span class="info-val">{{ viewStudent.fullname || '-' }}<template v-if="viewStudent.nickname"> ({{ viewStudent.nickname }})</template></span>
                </div>
                <div class="info-row">
                    <span class="info-label"><span class="mdi mdi-cake-variant-outline"></span> {{ $t('table.age') }}</span>
                    <span class="info-val">{{ viewStudent.dateofbirth ? calculateAge(viewStudent.dateofbirth).text : '-' }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label"><span class="mdi mdi-gender-male-female"></span> {{ $t('table.gender') }}</span>
                    <span class="info-val">{{ viewGenderLabel }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label"><span class="mdi mdi-stairs-up"></span> {{ $t('table.level') }}</span>
                    <span class="info-val">{{ viewStudent.level || '-' }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label"><span class="mdi mdi-school-outline"></span> {{ $t('table.school') }}</span>
                    <span class="info-val">{{ viewStudent.school || '-' }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label"><span class="mdi mdi-account-child-outline"></span> {{ $t('table.parentUsername') }}</span>
                    <span class="info-val">{{ viewStudent.parentusername || '-' }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label"><span class="mdi mdi-book-account-outline"></span> {{ $t('learningHistory.currentCourse') }}</span>
                    <span class="info-val">{{ viewCourseLabel }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label"><span class="mdi mdi-ticket-confirmation-outline"></span> {{ $t('table.remaining') }}</span>
                    <span class="info-val">{{ viewRemainingLabel }}</span>
                </div>
                <div v-if="viewStudent.expiredate" class="info-row">
                    <span class="info-label"><span class="mdi mdi-calendar-alert"></span> {{ $t('table.expireDate') }}</span>
                    <span class="info-val" :class="{ 'highlighted-red': isExpiredDate(viewStudent.expiredate) }">{{ expireDateLeft(viewStudent.expiredate) }}</span>
                </div>
            </div>

            <!-- ประวัติเลเวล (tstudent_level_history) — มาจากผลการแข่งของอีเวนต์ หรือแก้เองที่หน้านักเรียน -->
            <div class="modal-sec mt"><span class="mdi mdi-stairs-up"></span> {{ $t('levelRes.historyTitle') }}</div>
            <div v-if="!levelHistory.length" class="lvh-empty">{{ $t('levelRes.historyEmpty') }}</div>
            <div v-for="h in levelHistory" :key="h.id" class="lvh-row" :class="{ voided: Number(h.voided) === 1 }">
                <span class="lvh-lv">{{ h.old_level ?? '-' }} → {{ h.new_level ?? '-' }}</span>
                <span class="lvh-src">
                    <template v-if="h.eventid">{{ $t('levelRes.fromEvent', { name: h.eventname || ('#' + h.eventid), date: h.eventdate ? $formatShortDate(h.eventdate) : '-' }) }}</template>
                    <template v-else>{{ $t('levelRes.manual') }}</template>
                    <span v-if="h.result_note"> · {{ h.result_note }}</span>
                </span>
                <span class="lvh-by">{{ $t('levelRes.by', { by: h.createby || '-', at: h.createdate }) }}<template v-if="Number(h.voided) === 1"> · {{ $t('levelRes.voidedBy', { by: h.voidby || '-' }) }}</template></span>
            </div>

            <div class="modal-sec mt"><span class="mdi mdi-history"></span> {{ $t('learningHistory.tableTitle') }}</div>
            <div class="lh-sum">
                <div class="lh-tile"><div class="lh-lbl">{{ $t('learningHistory.sumTotal') }}</div><div class="lh-val">{{ historySummary.total }}</div></div>
                <div class="lh-tile"><div class="lh-lbl">{{ $t('learningHistory.sumGroup') }}</div><div class="lh-val">{{ historySummary.group }}</div></div>
                <div class="lh-tile"><div class="lh-lbl">{{ $t('learningHistory.sumPrivate') }}</div><div class="lh-val">{{ historySummary.private }}</div></div>
                <div class="lh-tile"><div class="lh-lbl">{{ $t('learningHistory.sumFree') }}</div><div class="lh-val">{{ historySummary.free }}</div></div>
            </div>
            <!-- read-only log แบบเดียวกับ course-usage sub-table เดิม → ยกเว้นไม่ต้องทำ pagination/skeleton -->
            <div class="id-modal-grid" style="margin-top:10px"><div class="id-modal-grid-scroll" style="max-height:38vh">
                <table class="idt">
                    <thead><tr>
                        <th style="width:46px">#</th>
                        <th>{{ $t('table.date') }}</th>
                        <th>{{ $t('table.time') }}</th>
                        <th style="text-align:center">{{ $t('learningHistory.colType') }}</th>
                        <th>{{ $t('table.courseName') }}</th>
                        <th>{{ $t('learningHistory.colCoach') }}</th>
                        <th style="text-align:center">{{ $t('table.checkin') }}</th>
                    </tr></thead>
                    <!-- ไม่ใส่ .id-fade-in: dialog นี้ถูกสร้างใหม่ทุกครั้งที่เปิด และตัว modal เฟดเข้าอยู่แล้ว
                         ซ้อนอีกชั้นจะเห็นเป็นตารางกระพริบ (เจ้าของแจ้ง 2026-08-22) -->
                    <tbody>
                        <tr v-for="(row, i) in historyList" :key="row.kind + '-' + row.id">
                            <td>{{ i + 1 }}</td>
                            <td>{{ format_date(row.eventdate) }}</td>
                            <td>{{ row.classtime || '-' }}</td>
                            <td style="text-align:center">
                                <span class="badge" :class="historyTypeClass(row)">{{ historyTypeLabel(row) }}</span>
                                <span v-if="row.per_session == 1" class="badge badge-session" style="margin-left:4px">{{ $t('learningHistory.badgeWalkin') }}</span>
                                <span v-if="row.freeflag == 1" class="badge badge-info" style="margin-left:4px">{{ $t('learningHistory.badgeFree') }}</span>
                            </td>
                            <td>{{ historyCourseLabel(row) }}</td>
                            <td>{{ row.kind === 'private' ? (row.coachname || '-') : '-' }}</td>
                            <td style="text-align:center">
                                <span v-if="row.checkedin == 1" class="mdi mdi-check-circle" style="color:var(--c-success);font-size:18px"></span>
                                <span v-else style="color:var(--c-text-muted)">-</span>
                            </td>
                        </tr>
                        <tr v-if="!historyList.length">
                            <td colspan="7" style="text-align:center;color:var(--c-text-muted)">{{ $t('learningHistory.noHistory') }}</td>
                        </tr>
                    </tbody>
                </table>
            </div></div>
            <template #footer>
                <button class="id-btn id-btn-primary" @click="dialogStudentView = false">{{ $t('btn.close') }}</button>
            </template>
        </id-modal>

        <!-- ===== ประวัติการแก้ไขข้อมูลนักเรียน (read-only) — ไทม์ไลน์ taction_log ===== -->
        <id-modal v-model="dialogStudentHistory" size="sm" icon="mdi-history"
            :title="$t('editHistory.title')" :subtitle="studentHistoryTitle">
            <edit-history-timeline v-if="dialogStudentHistory" kind="student"
                :refid="studentHistoryRefid" :preloaded="studentHistoryData"></edit-history-timeline>
            <template #footer>
                <button class="id-btn id-btn-primary" @click="dialogStudentHistory = false">{{ $t('btn.close') }}</button>
            </template>
        </id-modal>

        <!-- ===== เตือน "อาจเป็นเด็กคนเดียวกัน" — component ร่วมกับจอจัดการบัญชี =====
             ⚠️ ต้องอยู่ **หลัง** id-modal ตัวอื่นทุกตัวในไฟล์ ไม่งั้นถูกฟอร์มที่เปิดค้างบัง -->
        <!-- แถวในคิวที่ "ซ้ำกับตัวจริง" — อธิบายว่าต้องรวมประวัติ ไม่ใช่ย้าย -->
        <id-modal v-model="dialogMerge" size="lg" icon="mdi-content-duplicate" :title="$t('dup.mergeTitle')"
            :subtitle="$t('dup.mergeSubtitle')">
            <div class="mg-warn">
                <span class="mdi mdi-alert-circle-outline"></span>
                <div>{{ $t('dup.mergeExplain') }}</div>
            </div>
            <div v-if="mergeRow" class="mg-pair">
                <div class="mg-side">
                    <div class="mg-label">{{ $t('dup.mergeFrom') }}</div>
                    <div class="mg-name">{{ mergeRow.fullname }}<span v-if="mergeRow.nickname" class="unc-nick">({{ mergeRow.nickname }})</span></div>
                    <div class="mg-meta">{{ mergeRow.studentid }}</div>
                    <div class="mg-meta">{{ mergeRow.family_username || $t('dup.noFamily') }} · {{ $t('dup.bookings', { n: mergeRow.bookings }) }}</div>
                </div>
                <span class="mdi mdi-arrow-right mg-arrow"></span>
                <div class="mg-side">
                    <div class="mg-label">{{ $t('dup.mergeTo') }}</div>
                    <div v-for="m in mergeRow.matches" :key="m.studentid" class="mg-cand">
                        <div class="mg-name">{{ m.fullname }}<span v-if="m.nickname" class="unc-nick">({{ m.nickname }})</span>
                            <span class="dup-conf" :class="'cf-' + m.confidence">{{ $t('dup.conf.' + m.confidence) }}</span></div>
                        <div class="mg-meta">{{ m.studentid }}</div>
                        <div class="mg-meta">{{ m.family_username }} · {{ $t('dup.bookings', { n: m.bookings }) }} · {{ $t('dup.why.' + m.matchKey) }}</div>
                        <!-- ผู้จัดการเท่านั้น (backend บังคับซ้ำ) · อ่านสิทธิ์ไม่ได้ = โชว์ไว้ ให้ backend ตัดสิน
                             ไม่มีปุ่มบนคู่ medium (นามสกุล+วันเกิด) — คือคู่ที่ยิงใส่ฝาแฝดจริง backend ก็ปฏิเสธ -->
                        <button v-if="canMerge && m.confidence !== 'medium'" class="id-btn id-btn-primary id-btn-sm mg-do"
                            @click="startMerge(m)"><span class="mdi mdi-call-merge"></span> {{ $t('dup.mergeBtn') }}</button>
                    </div>
                </div>
            </div>
            <div class="mg-how">{{ $t('dup.mergeHow') }}</div>
            <template #footer>
                <button class="id-btn id-btn-primary" @click="dialogMerge = false">{{ $t('btn.close') }}</button>
            </template>
        </id-modal>

        <!-- ยืนยันการรวม — ย้อนกลับยาก จึงต้องติ๊กยืนยันว่าตรวจแล้วว่าเป็นคนเดียวกัน -->
        <id-modal v-model="dialogMergeConfirm" size="sm" icon="mdi-call-merge" :title="$t('dup.mergeConfirmTitle')" persistent>
            <p v-if="mergeRow && mergeTarget" style="margin:0 0 10px">{{ $t('dup.mergeConfirm', {
                from: mergeRow.fullname + ' · ' + mergeRow.studentid,
                to: mergeTarget.fullname + ' · ' + mergeTarget.studentid,
                n: mergeRow.bookings }) }}</p>
            <label class="id-cbx" @click="mergeChecked = !mergeChecked">
                <span class="id-check" :class="{ on: mergeChecked }"><span class="mdi mdi-check"></span></span>
                <span>{{ $t('dup.mergeCheck') }}</span>
            </label>
            <template #footer>
                <button class="id-btn id-btn-ghost" @click="dialogMergeConfirm = false">{{ $t('btn.cancel') }}</button>
                <button class="id-btn id-btn-primary" :disabled="!mergeChecked || moveBusy" @click="doMerge">
                    <span class="mdi mdi-call-merge"></span> {{ $t('dup.mergeBtn') }}</button>
            </template>
        </id-modal>

        <!-- แถวในคิวที่ยังไม่มีตัวจริง — ย้ายเข้าครอบครัวที่แอดมินเลือกเอง -->
        <id-modal v-model="dialogAssign" size="md" icon="mdi-home-plus-outline" :title="$t('dup.assignTitle')"
            :subtitle="assignRow ? assignRow.fullname : ''" persistent>
            <div class="mg-how" style="margin-top:0">{{ $t('dup.assignExplain') }}</div>
            <div class="field"><label>{{ $t('table.parentUsername') }} <span class="req">*</span></label>
                <id-select v-model="assignFamilyId" searchable :placeholder="$t('common.select')"
                    :search-placeholder="$t('gymnasts.typeUsername')"
                    :options="familyLookup.map(f => ({ value: f.familyid, label: f.username }))"></id-select></div>
            <template #footer>
                <button class="id-btn id-btn-ghost" @click="dialogAssign = false">{{ $t('btn.cancel') }}</button>
                <button class="id-btn id-btn-primary" :disabled="!assignFamilyId || moveBusy" @click="doAssign">
                    <span class="mdi mdi-account-arrow-right-outline"></span> {{ $t('dup.assignBtn') }}</button>
            </template>
        </id-modal>

        <duplicate-student-dialog v-model="dialogDup" :candidates="dupCandidates"
            :target-family-id="dupTargetFamilyId" :busy="moveBusy"
            @move="moveIntoFamily" @create-anyway="createAnyway" />
    </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
import { preloadImage } from "@/utils/image";
import { fetchEditHistory } from "@/utils/history";
export default {
    props: {
        // null = all students; 'ga' / 'istar' = pre-filter by program (course_shortname). Set by the split menus.
        program: { type: String, default: null },
    },
    data() {
        return {
            search: "",
            // search-page filters (server-side)
            filterStatus: "",
            filterGender: "",
            filterCourse: "",
            courseOptions: [],
            uploadLoading: false,
            StudentList: [],
            imagePreview: require("@/assets/avatar/2.png"),
            StudentListHeadersData: [],
            editedStudentItem: {
                studentid: null,
                familyid: null,
                firstname: null,
                middlename: null,
                lastname: null,
                nickname: null,
                gender: null,
                dateofbirth: null,
                level: null,
                age: null,
                courserefer: null,
                courserefer2: null,
                username: null,
                profile_image: null,
                profile_image_url: null,
                shortnote: null,
            },
            defaultStudentItem: {
                studentid: null,
                familyid: null,
                firstname: null,
                middlename: null,
                lastname: null,
                nickname: null,
                gender: null,
                dateofbirth: null,
                level: null,
                age: null,
                courserefer: null,
                courserefer2: null,
                username: null,
                profile_image: null,
                profile_image_url: null,
                shortnote: null,
            },
            CourseUsingHeadersData: [],
            CourseUsingtList: [],
                // ใครถือแพ็กเกจนี้อยู่ / เคยใช้ — จาก /getStudentCourseDetail (CourseHoldersLine.vue)
                courseHolders: null,
                courseEverUsed: null,
                // เพดานผู้ใช้ร่วมต่อแพ็กเกจ — อ่านจาก /getCustomerCourseLookup ห้าม hardcode
                // (กติกาเดียวกับ creditCardFeeRate) · ค่าตั้งต้นเผื่อ backend รุ่นเก่าที่ยังไม่ส่งมา
                maxCourseShare: 4,
                // ลำดับคำขอของ onCourseChange — สลับดรอปดาวน์เร็ว ๆ แล้วผลของใบแรกมาถึงทีหลัง
                // จะเขียนทับใบที่เลือกอยู่จริง (ไอเดียเดียวกับ seq ที่ใช้กันผลมาช้าในไฟล์อื่น)
                courseFetchSeq: 0,
            base64Image: null,
            editedStudentIndex: -1,
            dialogStudent: false,
            // dialog "ดูข้อมูล + ประวัติการเรียน" (read-only) — โหลดตอนกดปุ่มลูกตาเท่านั้น
            dialogStudentView: false,
            levelHistory: [],
            viewStudent: {},
            // dialog "ประวัติการแก้ไข" (read-only) — ไทม์ไลน์ taction_log ของนักเรียนคนนี้
            // preload ก่อนเปิดตามกติกา "เปิด dialog เมื่อข้อมูลครบ"
            dialogStudentHistory: false,
            studentHistoryRefid: null,
            studentHistoryTitle: '',
            studentHistoryData: null,
            // รูปเด็กในไดอะล็อกปุ่มลูกตา — โหลดแยกจาก /student/:id/profile-image เพราะ /getStudentList
            // ไม่ได้คืน profile_image_url มากับแถวในตาราง (และไฟล์ใน Spaces เป็น private จึงต้องใช้
            // presigned URL ที่ endpoint นั้นเซ็นให้ ใช้ URL ถาวรตรง ๆ จะได้ 403)
            viewImageUrl: null,
            historyList: [],
            historySummary: { total: 0, group: 0, private: 0, free: 0 },
            dialogStudentDelete: false,
            loadingStudent: false,
            dialogFinish: false,
            notNullRules: [(v) => !!v || this.$t("common.required")],
            totalStudents: 0,
            tableOptions: { page: 1, itemsPerPage: 10, sortBy: [] },
            searchTimer: null,
            isMounted: false,
            currentActive: false,
            // ── กันเด็กซ้ำ (เจ้าของสั่ง 2026-09-07) ────────────────────────────────
            tab: 'list',
            unclaimed: [],
            unclaimedCounts: { total: 0, noFamily: 0, withCourse: 0, withBookings: 0, withMatch: 0 },
            unclaimedLoaded: false,
            loadingUnclaimed: false,
            unclaimedPaging: false,
            unclaimedSearch: '',
            unclaimedPage: 1,
            unclaimedPerPage: 10,
            unclaimedFilter: '',
            unclaimedSort: [],
            dialogMerge: false,
            mergeRow: null,
            dialogMergeConfirm: false,
            mergeTarget: null,
            mergeChecked: false,
            dialogAssign: false,
            assignRow: null,
            assignFamilyId: null,
            dialogDup: false,
            dupCandidates: [],
            // ใบที่ backend ตีกลับมาพร้อมคำเตือน — เก็บไว้ยิงซ้ำเมื่อแอดมินยืนยันว่าคนละคน
            dupPendingObj: null,
            dupTargetFamilyId: null,
            moveBusy: false,
        };
    },
    async created() {
        try {
            const token = this.$store.getters.getToken;
            //console.log("token ", token);
            if (!token) {
                this.errorMsg = "Not found token, Please login...";
                this.errorDialog = true;
                this.$emit("onClickChangeState", "login");
                return;
            }

            await axios
                .post(
                    this.baseURL + "/verifyToken",
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                )
                .then((response) => {
                    //console.dir(response);
                    if (response.data.success) {
                        this.initialize();
                    }
                })
                .catch((error) => {
                    //console.error(error);
                    this.$emit("onErrorHandler", error.response.data.message);
                    this.$emit("onClickChangeState", "login");
                });
        } catch (error) {
            this.$emit("onErrorHandler", error.message);
        }
    },
    mounted() {
        this.isMounted = true;
    },
    methods: {
        async initialize() {
            this.tableOptions.page = 1;
            this.$emit("onLoading", true);
            await this.getCustomerCourseLookup();
            await this.getFamilyLookup();
            await this.getCourseOptions();
            await this.getStudentList(false);

            this.$emit("onLoading", false);
        },
        async initializeActive() {
            this.$emit("onLoading", true);
            await this.getCustomerCourseLookup();
            await this.getFamilyLookup();
            await this.getStudentList(true);

            this.$emit("onLoading", false);
        },
        // animate = true only for grid page / per-page changes → ≥1s skeleton.
        async getStudentList(active, animate = false) {
            this.currentActive = active;
            this.loadingStudent = true;
            const t0 = Date.now();
            const token = this.$store.getters.getToken;
            const { page, itemsPerPage, sortBy } = this.tableOptions;
            await ComponentAPI.fetchDataStudent({
                token, active, page, itemsPerPage, search: this.search, sortBy,
                program: this.program, status: this.filterStatus, gender: this.filterGender, courseid: this.filterCourse,
            })
                .then(async ({ success, results, total, message }) => {
                    if (success) {
                        this.StudentList = results;
                        this.totalStudents = total ?? 0;
                    } else {
                        this.$emit("onErrorHandler", message || this.$t("msg.studentListFail"));
                    }
                    if (animate) await this.$minLoad(t0);
                    this.loadingStudent = false;
                })
                .catch(async (error) => {
                    if (animate) await this.$minLoad(t0);
                    this.loadingStudent = false;
                    if (error.response && error.response.status == 401) {
                        this.$emit("onErrorHandler", error.response.data.message);
                        this.$emit("onClickChangeState", "login");
                    } else {
                        this.$emit("onErrorHandler", error.message);
                    }
                });
        },
        onTableOptions({ page, itemsPerPage, sortBy }) {
            this.tableOptions = { ...this.tableOptions, page, itemsPerPage, sortBy };
            if (!this.isMounted) return;
            this.getStudentList(this.currentActive);
        },
        // click a sortable header → cycle the server sortBy (none→asc→desc→none), reset to page 1, refetch.
        applySort(h) {
            if (h.sortable === false) return;
            this.tableOptions.sortBy = this.$toggleSort(this.tableOptions.sortBy, h.key);
            this.tableOptions.page = 1;
            this.getStudentList(this.currentActive, true);
        },
        // A search-page filter changed → reset to page 1 and refetch (server-side).
        applyFilter() {
            this.tableOptions.page = 1;
            this.getStudentList(this.currentActive);
        },
        // Course options for the course filter (distinct courses from tcourseinfo).
        async getCourseOptions() {
            try {
                const res = await axios.get(this.baseURL + "/getAllCourses", {
                    headers: { Authorization: `Bearer ${this.$store.getters.getToken}` },
                });
                this.courseOptions = res.data && res.data.success ? (res.data.results || []) : [];
            } catch (e) { this.courseOptions = []; }
        },
        async doSaveNewStudent() {
            this.$emit("onLoading", true);
            const { valid } = await this.$refs.newstdform.validate();
            if (valid) {
                // Make API request to register the user
                let dob = null;
                if(this.editedStudentItem.dateofbirth){
                    dob = this.SQLDate(this.editedStudentItem.dateofbirth);
                }
                const StudentObj = {
                    studentid: this.editedStudentItem.studentid,
                    firstname: this.editedStudentItem.firstname,
                    middlename: this.editedStudentItem.middlename,
                    lastname: this.editedStudentItem.lastname,
                    nickname: this.editedStudentItem.nickname,
                    gender: this.editedStudentItem.gender,
                    dateofbirth: dob,
                    level: this.editedStudentItem.level,
                    familyid: this.editedStudentItem.familyid,
                    courserefer: this.editedStudentItem.courserefer,
                    courserefer2: this.editedStudentItem.courserefer2,
                    shortnote: this.editedStudentItem.shortnote,
                    profile_image_url: this.editedStudentItem.profile_image_url,
                };

                //console.log(this.editedStudentIndex+ ' StudentObj : ', StudentObj)
                const token = this.$store.getters.getToken;
                if (this.editedStudentIndex > -1) {
                    StudentObj.studentid = this.editedStudentItem.studentid;
                    // เลเวลตอนเปิดฟอร์ม — ไม่แตะช่องนี้ backend จะไม่เขียนทับเลเวลที่หน้าผลการแข่งเพิ่งเลื่อนไป
                    StudentObj.level_orig = this.editedStudentItem.level_orig;
                    await axios
                        .post(this.baseURL + "/updateStudentByAdmin", StudentObj, {
                            headers: { Authorization: `Bearer ${token}` },
                        })
                        .then((response) => {
                            if (response.data.success) {
                                this.handleProfileImageUpload(this.editedStudentItem.profile_image, this.editedStudentItem.studentid);
                                //this.uploadImageProfile(this.editedStudentItem.studentid);
                                this.$emit("onInfoHandler", this.$t('msg.updated'));
                                this.getStudentList();
                                this.dialogStudent = false;
                                this.$emit("onUpdateDataSuccess");
                            } else {
                                this.$emit(
                                    "onErrorHandler",
                                    response.data.message || this.$t('msg.updateFail')
                                );
                            }
                        })
                        .catch((error) => {
                            //console.log(error);
                            if (error.response?.status && error.response.status == 401) {
                                this.$emit("onErrorHandler", error.response.data.message);
                                this.$emit("onClickChangeState", "login");
                            } else {
                                this.$emit("onErrorHandler", error.message);
                            }
                        });
                } else {
                    await axios
                        .post(this.baseURL + "/addStudentByAdmin", StudentObj, {
                            headers: { Authorization: `Bearer ${token}` },
                        })
                        .then((response) => {
                            if (response.data.success) {
                                this.handleProfileImageUpload(this.editedStudentItem.profile_image, response.data.studentid);
                                //this.uploadImageProfile(response.data.studentid);
                                this.$emit("onInfoHandler", this.$t('msg.memberAdded'));
                                this.getStudentList();
                                this.dialogStudent = false;
                            } else if (response.data.duplicateWarning) {
                                // backend เจอเด็กที่น่าจะเป็นคนเดียวกัน — ยังไม่สร้างให้ ถามก่อน
                                // เก็บใบเดิมไว้ยิงซ้ำพร้อม confirmDuplicate ถ้าแอดมินบอกว่าคนละคน
                                this.dupCandidates = response.data.candidates || [];
                                this.dupPendingObj = StudentObj;
                                this.dupTargetFamilyId = StudentObj.familyid;
                                this.dialogDup = true;
                            } else {
                                this.$emit(
                                    "onErrorHandler",
                                    response.data.message || this.$t('msg.memberAddFail')
                                );
                            }
                            this.$emit("onUpdateDataSuccess");
                        })
                        .catch((error) => {
                            if (error.response?.status && error.response.status == 401) {
                                this.$emit("onErrorHandler", error.response.data.message);
                                this.$emit("onClickChangeState", "login");
                            } else {
                                this.$emit("onErrorHandler", error.message);
                            }
                        });
                }
            }
            this.$emit("onLoading", false);
        },
        // ── กันเด็กซ้ำ ────────────────────────────────────────────────────────────
        // "คนละคน — สร้างใหม่": ยิงใบเดิมซ้ำพร้อม confirmDuplicate ให้ backend ข้ามด่านเตือน
        async createAnyway(reason) {
            if (!this.dupPendingObj) return;
            this.$emit("onLoading", true);
            try {
                const res = await axios.post(this.baseURL + "/addStudentByAdmin",
                    { ...this.dupPendingObj, confirmDuplicate: true, reason },
                    { headers: { Authorization: `Bearer ${this.$store.getters.getToken}` } });
                if (res.data.success) {
                    this.handleProfileImageUpload(this.editedStudentItem.profile_image, res.data.studentid);
                    this.$emit("onInfoHandler", this.$t('msg.memberAdded'));
                    this.closeDupDialog();
                    this.dialogStudent = false;
                    this.getStudentList();
                } else {
                    this.$emit("onErrorHandler", res.data.message || this.$t('msg.memberAddFail'));
                }
            } catch (e) {
                this.$emit("onErrorHandler", e.message);
            } finally {
                this.$emit("onLoading", false);
            }
        },
        // "ย้ายเข้าครอบครัวนี้": ใช้ /transferStudent ที่มีอยู่แล้ว — ประวัติและคอร์สติดตามไปเอง
        // เพราะทุกอย่างผูกกับ studentid ไม่ได้ผูกกับ familyid (จึงไม่ต้องย้ายข้อมูลอะไรเลย)
        // ใช้เฉพาะตอนสร้างเด็กใหม่แล้วพบว่าซ้ำ: ย้ายแถวเดิมเข้าครอบครัวที่แอดมินกำลังกรอกอยู่
        async moveIntoFamily(candidate) {
            const studentid = candidate.studentid;
            const familyid = this.dupTargetFamilyId;
            if (!familyid || !studentid) return;
            this.moveBusy = true;
            this.$emit("onLoading", true);
            try {
                const res = await axios.post(this.baseURL + "/transferStudent",
                    { studentid, familyid },
                    { headers: { Authorization: `Bearer ${this.$store.getters.getToken}` } });
                if (res.data.success) {
                    this.$emit("onInfoHandler", this.$t('dup.moved'));
                    this.closeDupDialog();
                    this.dialogStudent = false;
                    this.getStudentList();
                    // แถวที่เพิ่งย้ายอาจอยู่ในคิว "ยังไม่มีผู้ปกครอง" — โหลดใหม่ให้ตัวเลขตรง
                    if (this.unclaimedLoaded) this.loadUnclaimed(true);
                } else {
                    this.$emit("onErrorHandler", res.data.message);
                }
            } catch (e) {
                // 403 = ไม่ใช่ head/admin (โค้ชที่ได้เมนู gymnastmanager ย้ายครอบครัวไม่ได้)
                this.$emit("onErrorHandler", e.response?.data?.message || e.message);
            } finally {
                this.moveBusy = false;
                this.$emit("onLoading", false);
            }
        },
        closeDupDialog() {
            this.dialogDup = false;
            this.dupCandidates = [];
            this.dupPendingObj = null;
            this.dupTargetFamilyId = null;
        },
        // ── แท็บ "ยังไม่มีผู้ปกครอง" ───────────────────────────────────────────────
        switchToUnclaimed() {
            this.tab = 'unclaimed';
            if (!this.unclaimedLoaded) this.loadUnclaimed();
        },
        async loadUnclaimed(force) {
            if (this.loadingUnclaimed) return;
            if (this.unclaimedLoaded && !force) return;
            this.loadingUnclaimed = true;
            try {
                const res = await axios.get(this.baseURL + "/getUnclaimedStudents",
                    { headers: { Authorization: `Bearer ${this.$store.getters.getToken}` } });
                if (res.data.success) {
                    // ⚠️ normalize ที่จุดเดียว: FE กับ BE ขึ้น prod คนละ PR ถ้า FE ขึ้นก่อน
                    // response เก่าจะไม่มี matches/needMerge แล้ว computed จะ throw ทั้งแท็บ
                    this.unclaimed = (res.data.results || []).map((r) => ({
                        ...r, matches: r.matches || [], needMerge: !!r.needMerge,
                    }));
                    this.unclaimedCounts = { ...this.unclaimedCounts, ...(res.data.counts || {}) };
                    this.unclaimedLoaded = true;
                    this.unclaimedPage = 1;
                } else {
                    this.$emit("onErrorHandler", res.data.message || this.$t("msg.loadFail"));
                }
            } catch (e) {
                if (e.response?.status === 401) {
                    this.$emit("onErrorHandler", e.response.data.message);
                    this.$emit("onClickChangeState", "login");
                } else {
                    this.$emit("onErrorHandler", e.message);
                }
            } finally {
                this.loadingUnclaimed = false;
            }
        },
        // กริดนี้แบ่งหน้าฝั่ง client (ทันที) จึงต้องหน่วง skeleton เองให้ครบ 1 วิ ตามมาตรฐานกริด
        // "เปลี่ยนหน้าต้องอ่านว่าเป็นการโหลด ไม่ใช่เฟดเฉย ๆ" (CLAUDE.md §Pagination + loading + fade)
        async runUnclaimedPaging(apply) {
            // ใช้ flag แยกจาก loadingUnclaimed — ไม่งั้นระหว่างหน่วง 1 วิ ปุ่มรีเฟรชจะกดไม่ติด
            // (loadUnclaimed early-return เมื่อ loadingUnclaimed เป็น true)
            const t0 = Date.now();
            this.unclaimedPaging = true;
            apply();
            await this.$minLoad(t0);
            this.unclaimedPaging = false;
        },
        toggleUncFilter(f) {
            this.unclaimedFilter = this.unclaimedFilter === f ? '' : f;
            this.unclaimedPage = 1;
        },
        // แถวนี้ซ้ำกับตัวจริงที่มีอยู่แล้ว — อธิบายว่าทำไมย้ายไม่ได้ ต้องรวมประวัติแทน
        openMergeInfo(row) {
            if (!row.matches.length) return;
            this.mergeRow = row;
            this.dialogMerge = true;
        },
        startMerge(target) {
            this.mergeTarget = target;
            this.mergeChecked = false;
            this.dialogMergeConfirm = true;
        },
        // รวมแถวในคิว (mergeRow) เข้ากับแถวจริง (mergeTarget) — POST /mergeStudent (ผู้จัดการเท่านั้น)
        // code ที่ backend คืนเมื่อชนกัน แปลเป็นภาษาของผู้ใช้เอง (dup.mergeErr.*)
        async doMerge() {
            if (!this.mergeRow || !this.mergeTarget) return;
            this.moveBusy = true;
            this.$emit("onLoading", true);
            try {
                const res = await axios.post(this.baseURL + "/mergeStudent",
                    { keepStudentId: this.mergeTarget.studentid, mergeStudentId: this.mergeRow.studentid },
                    { headers: { Authorization: `Bearer ${this.$store.getters.getToken}` } });
                if (res.data.success) {
                    this.dialogMergeConfirm = false;
                    this.dialogMerge = false;
                    await this.loadUnclaimed(true);
                    this.$emit("onInfoHandler", this.$t('dup.mergeDone'));
                } else {
                    const known = ['booking_conflict', 'event_conflict', 'course_slots', 'private_conflict', 'not_found', 'direction', 'not_candidate'].includes(res.data.code);
                    let msg = known ? this.$t('dup.mergeErr.' + res.data.code) : (res.data.message || this.$t('dup.mergeFail'));
                    if (res.data.dates && res.data.dates.length) msg += ' (' + res.data.dates.map((d) => this.$formatShortDate(d)).join(', ') + ')';
                    this.$emit("onErrorHandler", msg);
                }
            } catch (error) {
                this.$emit("onErrorHandler", (error.response && error.response.data && error.response.data.message) || this.$t('dup.mergeFail'));
            } finally {
                this.moveBusy = false;
                this.$emit("onLoading", false);
            }
        },
        // แถวนี้ยังไม่มีตัวจริงในระบบ = ผู้ปกครองยังไม่เคยสมัคร (หรือสมัครแล้วแต่ยังไม่เพิ่มชื่อลูก)
        // อันนี้ "ย้าย" ได้จริง เพราะไม่มีแถวซ้ำให้ชนกัน
        openAssign(row) {
            this.assignRow = row;
            this.assignFamilyId = null;
            this.dialogAssign = true;
        },
        async doAssign() {
            if (!this.assignRow || !this.assignFamilyId) return;
            this.moveBusy = true;
            this.$emit("onLoading", true);
            try {
                const res = await axios.post(this.baseURL + "/transferStudent",
                    { studentid: this.assignRow.studentid, familyid: this.assignFamilyId },
                    { headers: { Authorization: `Bearer ${this.$store.getters.getToken}` } });
                if (res.data.success) {
                    this.$emit("onInfoHandler", this.$t('dup.moved'));
                    this.dialogAssign = false;
                    this.assignRow = null;
                    await this.loadUnclaimed(true);
                    this.getStudentList();
                } else {
                    this.$emit("onErrorHandler", res.data.message);
                }
            } catch (e) {
                // 403 = ไม่ใช่ head/admin (โค้ชที่ได้เมนู gymnastmanager ย้ายครอบครัวไม่ได้)
                this.$emit("onErrorHandler", e.response?.data?.message || e.message);
            } finally {
                this.moveBusy = false;
                this.$emit("onLoading", false);
            }
        },
        finishCourse() {
            this.dialogFinish = true;
        },
        async finishCourseConfirm() {
        this.$emit("onLoading", true);
        const token = this.$store.getters.getToken;
            await axios
                .post(
                this.baseURL + "/finishCustomerCourse",
                {
                    courserefer: this.editedStudentItem.courserefer,
                },
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
                )
                .then((response) => {
                //console.dir(response);
                if (response.data.success) {
                    this.dialogFinish = false;
                    this.getCustomerCourseLookup();
                    this.editedStudentItem.courserefer = null;
                    this.courseHolders = null;
                    this.courseEverUsed = null;
                    this.$emit("onInfoHandler", this.$t('msg.courseDone'));
                } else {
                    this.dialogFinish = false;
                    this.$emit(
                    "onErrorHandler",
                    response.data.message || this.$t('msg.updateFail')
                    );
                }
                this.initialize();
                })
                .catch(() => {
                //console.error(error);
                });
            this.$emit("onLoading", false);
        },
        closeFinish() {
            this.dialogFinish = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        async getCustomerCourseLookup() {
            const token = this.$store.getters.getToken;
            await axios
                .get(this.baseURL + "/getCustomerCourseLookup", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })
                .then((response) => {
                    //console.dir(response);
                    if (response.data.success) {
                        this.customerCourseLookup = response.data.results;
                        if (response.data.maxCourseShare) this.maxCourseShare = response.data.maxCourseShare;
                    }
                })
                .catch((error) => {
                    if (error.response?.status && error.response.status == 401) {
                        this.$emit("onErrorHandler", error.response.data.message);
                        this.$emit("onClickChangeState", "login");
                    } else {
                        this.$emit("onErrorHandler", error.message);
                    }
                });
        },
        async getFamilyLookup() {
            const token = this.$store.getters.getToken;
            await axios
                .get(this.baseURL + "/familyLookup", {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    //console.dir(response);
                    if (response.data.success) {
                        this.familyLookup = response.data.results;
                    }
                })
                .catch((error) => {
                    if (error.response?.status && error.response.status == 401) {
                        this.$emit("onErrorHandler", error.response.data.message);
                        this.$emit("onClickChangeState", "login");
                    } else {
                        this.$emit("onErrorHandler", error.message);
                    }
                });
        },
        async clickEditStudent(item) {
            console.log("clickEditStudent : ", item);
            
            this.editedStudentIndex = this.StudentList.indexOf(item);
            this.editedStudentItem = Object.assign({}, item, { level_orig: item.level });
            if(this.editedStudentItem.dateofbirth) {
                this.editedStudentItem.dateofbirth = new Date(item.dateofbirth);
                this.editedStudentItem.age = this.calculateAge(item.dateofbirth).text;
            }
            // ม่านโหลดจนกว่าทุกช่อง (ตัวเลือกคอร์ส/ครอบครัว + รูป) จะพร้อม แล้วค่อยเปิด
            this.$emit('onLoading', true);
            const photoDone = this.loadProfileImage();   // ยิงคู่ขนาน ไม่ขึ้นกับ lookup
            try {
                await this.getCustomerCourseLookup();
                await this.getFamilyLookup();
                await this.onCourseChange();
                await photoDone;
            } finally {
                this.$emit('onLoading', false);
            }
            this.dialogStudent = true;
        },
        // รูปเด็กสำหรับไดอะล็อกปุ่มลูกตา — ใช้ endpoint เดียวกับไดอะล็อกแก้ไข (`loadProfileImage`)
        // ซึ่งเช็คสิทธิ์ด้วย assertStudentAccess และเซ็น presigned URL ให้แล้ว
        // ⚠️ ห้ามโยน error ออกไป: ไม่มีรูปเป็นเรื่องปกติ (เด็กหลายคนยังไม่ได้อัปโหลด) และรูปโหลดไม่ได้
        // ต้องไม่ทำให้ประวัติการเรียนเปิดไม่ได้ — ล้มเงียบแล้วโชว์ไอคอนแทน
        async loadViewProfileImage(studentid) {
            if (!studentid) return;
            try {
                const response = await axios.get(
                    this.baseURL + `/student/${studentid}/profile-image`,
                    { headers: { Authorization: `Bearer ${this.$store.getters.getToken}` } }
                );
                // ผู้ใช้อาจกดดูเด็กคนอื่นต่อระหว่างที่คำขอนี้ยังค้างอยู่ — ทิ้งผลที่มาช้าไป
                // ไม่งั้นรูปเด็กคนก่อนจะไปโผล่บนไดอะล็อกของเด็กคนใหม่ (idiom เดียวกับโพลเงียบ 60 วิ)
                if (String(this.viewStudent.studentid) !== String(studentid)) return;
                if (response.data.success) {
                    const url = response.data.imageUrl || response.data.image || null;
                    // โหลดรูปเข้าแคชก่อนค่อยผูก src — ไม่งั้นเห็นไอคอนคนแว๊บก่อนรูปจริงมา
                    await preloadImage(url);
                    if (String(this.viewStudent.studentid) !== String(studentid)) return;
                    this.viewImageUrl = url;
                }
            } catch (e) {
                this.viewImageUrl = null;
            }
        },
        // ปุ่มลูกตา — โหลดประวัติการเรียนของเด็กคนนี้ (คลาสกลุ่ม + Private) แล้วเปิด dialog อ่านอย่างเดียว
        // ไม่โหลดล่วงหน้าทุกแถวในตาราง: เรียกตอนกดเท่านั้น
        async clickViewStudent(item) {
            this.$emit('onLoading', true);
            this.viewStudent = Object.assign({}, item);
            this.viewImageUrl = null;
            this.historyList = [];
            this.levelHistory = [];
            this.historySummary = { total: 0, group: 0, private: 0, free: 0 };
            // ยิงขอรูปคู่ขนานไปกับประวัติ แล้วรอทั้งคู่ก่อนเปิด — รูปมีเพดานเวลาในตัว (preloadImage)
            // และล้มเงียบเสมอ จึงไม่ทำให้ dialog เปิดช้าหรือเปิดไม่ได้ (ดู loadViewProfileImage)
            const photoDone = this.loadViewProfileImage(item.studentid);
            try {
                const [response, lvRes] = await Promise.all([
                    axios.get(
                        this.baseURL + '/getStudentLearningHistory/' + item.studentid,
                        { headers: { Authorization: `Bearer ${this.$store.getters.getToken}` } }
                    ),
                    // ประวัติเลเวลเป็นส่วนเสริม — พังแล้ว dialog ต้องยังเปิดได้
                    axios.get(
                        this.baseURL + '/getStudentLevelHistory/' + item.studentid,
                        { headers: { Authorization: `Bearer ${this.$store.getters.getToken}` } }
                    ).catch(() => null),
                    photoDone,
                ]);
                this.levelHistory = (lvRes && lvRes.data.success && lvRes.data.results) || [];
                if (response.data.success) {
                    // student จาก backend มี school/parentusername/coursetype ที่แถวใน grid ไม่มี
                    this.viewStudent = Object.assign({}, item, response.data.student || {});
                    this.historyList = response.data.results || [];
                    this.historySummary = Object.assign(this.historySummary, response.data.summary || {});
                    this.dialogStudentView = true;
                } else {
                    this.$emit('onErrorHandler', response.data.message || this.$t('learningHistory.loadFail'));
                }
            } catch (error) {
                if (error.response?.status && error.response.status == 401) {
                    this.$emit('onErrorHandler', error.response.data.message);
                    this.$emit('onClickChangeState', 'login');
                } else {
                    this.$emit('onErrorHandler', error.message || this.$t('learningHistory.loadFail'));
                }
            } finally {
                this.$emit('onLoading', false);
            }
        },
        // ปุ่มประวัติการแก้ไข — ดึงไทม์ไลน์ให้ครบก่อนเปิด dialog (กติกา "เปิดเมื่อข้อมูลครบ")
        // เหมือน showCourseInfo ใน CustomerCourse.vue เป๊ะ ต่างแค่ kind='student'
        async showStudentHistory(item) {
            this.studentHistoryRefid = item.studentid;
            this.studentHistoryTitle = item.fullname || item.nickname || item.studentid || '';
            this.$emit('onLoading', true);
            try {
                this.studentHistoryData = await fetchEditHistory(
                    this.baseURL, this.$store.getters.getToken, 'student', item.studentid);
            } finally {
                this.$emit('onLoading', false);
            }
            this.dialogStudentHistory = true;
        },
        // ป้ายประเภทของแถวประวัติ: Private / แข่ง (tclassinfo.classtype='event') / คลาสกลุ่ม
        historyTypeLabel(row) {
            if (row.kind === 'private') return this.$t('learningHistory.typePrivate');
            if (row.classtype === 'event') return this.$t('learningHistory.typeEvent');
            return this.$t('learningHistory.typeGroup');
        },
        historyTypeClass(row) {
            if (row.kind === 'private') return 'badge-session';
            if (row.classtype === 'event') return 'badge-warning';
            return 'badge-primary';
        },
        // คอลัมน์คอร์ส: กลุ่มใช้ชื่อย่อคอร์ส (คอร์สที่ถูกลบแล้วจะเป็น null → ขีด) · Private ใช้ประเภท + จำนวนชั่วโมง
        historyCourseLabel(row) {
            if (row.kind === 'private') {
                const hours = row.hours ? ` ${row.hours} ${this.$t('common.hoursUnit')}` : '';
                return `${row.privatetype || this.$t('learningHistory.typePrivate')}${hours}`;
            }
            return row.course_shortname || row.coursename || '-';
        },
        clickDeleteStudent(item) {
            this.editedStudentIndex = this.StudentList.indexOf(item);
            this.editedStudentItem = Object.assign({}, item);
            this.dialogStudentDelete = true;
        },
        async clickConfirmDeleteStd() {
            this.$emit("onLoading", true);
            const token = this.$store.getters.getToken;
            axios
                .post(
                    this.baseURL + "/deleteStudent",
                    {
                        familyid: this.editedStudentItem.familyid,
                        studentid: this.editedStudentItem.studentid,
                    },
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                )
                .then((response) => {
                    //console.dir(response);
                    if (response.data.success) {
                        this.$emit("onInfoHandler", this.$t("msg.studentDeleted"));
                        this.$emit("onUpdateDataSuccess");
                    } else {
                        this.$emit(
                            "onErrorHandler",
                            response.data.message || this.$t("msg.studentDeleteFail")
                        );
                    }
                    this.dialogStudentDelete = false;
                    this.initialize();
                    this.getStudentList();
                })
                .catch((error) => {
                    if (error.response?.status && error.response.status == 401) {
                        this.$emit("onErrorHandler", error.response.data.message);
                        this.$emit("onClickChangeState", "login");
                    } else {
                        this.$emit("onErrorHandler", error.message);
                    }
                });
            this.$emit("onLoading", false);
        },
        closeStudent() {
            this.dialogStudent = false;
            this.$nextTick(() => {
                this.editedStudentItem = Object.assign({}, this.defaultStudentItem);
                this.CourseUsingtList = [];
                this.courseHolders = null;   // ผู้ใช้ของนักเรียนคนก่อนห้ามไปโผล่ในฟอร์มถัดไป
                this.courseEverUsed = null;  // (เดิมค่านี้อยู่ใน editedStudentItem จึงถูกล้างเอง)
                this.editedStudentIndex = -1;
                this.imagePreview = this.profileAvatar;
            });
        },
        clickCancelDeleteStd() {
            this.dialogStudentDelete = false;
            this.$nextTick(() => {
                this.editedStudentItem = Object.assign({}, this.defaultStudentItem);
                this.editedStudentIndex = -1;
                this.imagePreview = this.profileAvatar;
            });
        },
        onFileClear() {
            this.editedStudentItem.profile_image = null;
            this.imagePreview = this.profileAvatar;
        },
        async onFileChange(e) {
            const file = e.target.files[0];
            //console.log("file : ", file);

            const maxSize = 4 * 1024 * 1024; // ขนาดสูงสุด 4MB
            if (file.size > maxSize) {
                this.editedStudentItem.profile_image = null;
                this.imagePreview = this.profileAvatar;
                this.$emit("onErrorHandler", this.$t("msg.fileTooLarge"));

                return;
            }
            if (file) {
                this.editedStudentItem.profile_image = file;
                const reader = new FileReader();
                reader.onload = () => {
                    this.imagePreview = reader.result;
                };
                reader.readAsDataURL(file);
            }
        },
        async loadProfileImage() {
            try {
                // Replace 'gymnastId' with the actual ID of the gymnast
                if(this.editedStudentItem.profile_image_url){
                    this.imagePreview = this.editedStudentItem.profile_image_url;
                } else {
                    const response = await axios.get(
                        this.baseURL +
                        `/student/${this.editedStudentItem.studentid}/profile-image`,
                        { headers: { Authorization: `Bearer ${this.token}` } }
                    );
                    //console.log("response : ", response);
                    //this.editedStudentItem.profile_image = response.data.image;
                    let profileImageUrl = response.data.imageUrl;
                    this.base64Image = response.data.image;
                    if (profileImageUrl) {
                        // โหลดเข้าแคชก่อนผูก src — dialog จะได้เปิดมาพร้อมรูป ไม่ใช่ไอคอนแล้วค่อยสลับ
                        await preloadImage(profileImageUrl);
                        this.imagePreview = profileImageUrl;
                    } else if (response.data.image !== null) {
                        this.imagePreview = `data:image/*;base64,${response.data.image}`;
                    } else {
                        this.imagePreview = this.profileAvatar;
                    }
                }
            } catch (error) {
                //console.error("Error loading profile image:", error);
            }
        },
        triggerFileInput() {
            this.$refs.fileInput.click();
        },
        async handleProfileImageUpload(file, sid) {
            if (this.editedStudentItem.profile_image_url && !file) {
                console.log('No new image to upload');
                return;
            }

            let fileToUpload = file;

            // ถ้าไม่มีไฟล์ ให้ตรวจสอบ this.base64Image
            if (!fileToUpload && this.base64Image) {

                let base64String = this.base64Image;
                if (!base64String.startsWith('data:image')) {
                    base64String = `data:image/jpeg;base64,${base64String}`;
                }

                const byteString = atob(base64String.split(',')[1]);
                const mimeString = base64String.split(',')[0].split(':')[1].split(';')[0];
                const ab = new ArrayBuffer(byteString.length);
                const ia = new Uint8Array(ab);
                for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i);
                }
                fileToUpload = new Blob([ab], { type: mimeString });
                fileToUpload = new File([fileToUpload], `${sid}.png`, { type: mimeString });
            }

            if (!fileToUpload) {
                console.error('No file to upload');
                return;
            }

            const formData = new FormData();
            const newFileName = `${sid}.${fileToUpload.name.split('.').pop()}`;

            // สร้างไฟล์ใหม่ด้วยชื่อไฟล์ใหม่
            const renamedFile = new File([fileToUpload], newFileName, { type: fileToUpload.type });

            formData.append('profileImage', renamedFile);
            formData.append('studentid', sid);

            const response = await fetch(this.baseURL + '/uploadProfileImage', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${this.token}`, // เพิ่ม token ลงใน headers
                },
                body: formData,
            });

            const data = await response.json();
            const imageUrl = data.url;
            console.log('imageUrl', imageUrl);
        },
        // คืน { text, level, icon } หรือ null (ไม่เลือก/ไม่พบ) — level เป็นคลาส CSS: '' | 'warn' | 'err'
        // ⚠️ ต้องตัด "เด็กที่กำลังแก้อยู่" ออกจากรายชื่อเสมอ แล้วสรุปท้ายด้วย "รวมคนนี้เป็น N คน"
        // ไม่งั้นแอดมินอ่านแล้วนับเองผิด — คนที่ถืออยู่แล้วกับคนที่กำลังจะถูกผูกปนกัน
        //
        // 🔑 เกณฑ์ต้องตรงกับ backend เป๊ะ (checkCourseShareCapacity): มันปฏิเสธเมื่อ
        // "จำนวนผู้ถือที่ไม่ใช่เด็กคนนี้" >= MAX_COURSE_SHARE — ไม่ใช่ "รวมคนนี้แล้ว >= MAX"
        // เขียนผิดข้างเดียวจอจะขึ้นแดงว่าบันทึกไม่ได้ทั้งที่บันทึกได้ (คนที่ 4 พอดีเพดาน)
        describeCourse(refer) {
            if (!refer) return null;
            const c = this.customerCourseLookup.find((x) => x.courserefer === refer);
            if (!c) return null;

            const me = this.editedStudentItem.studentid;
            const ids = String(c.holder_ids || '').split(',').filter(Boolean);
            const names = String(c.holder_names || '').split(', ').filter(Boolean);

            // holder_count มาจาก COUNT(*) จึงเป็นความจริงเสมอ ส่วน holder_names มาจาก GROUP_CONCAT
            // ซึ่ง **ข้ามแถวที่ nickname เป็น NULL** — สองอย่างนี้ยาวไม่เท่ากันได้ และเมื่อยาวไม่เท่ากัน
            // การจับคู่ตามดัชนีจะเลื่อน (ชื่อไปตรงกับ id ของคนอื่น) จนโชว์ชื่อ "ตัวเอง" เป็นคนที่แชร์ด้วย
            // → นับจาก holder_count เสมอ และจับคู่ชื่อเฉพาะตอนที่ยาวเท่ากันจริงเท่านั้น
            const holderCount = Number(c.holder_count || 0);
            const pairable = ids.length === names.length && ids.length === holderCount;
            const iAmHolder = !!me && ids.includes(me);
            // จำนวน "คนอื่น" ที่ถืออยู่ — ใช้ตัดสินทั้งข้อความและเกณฑ์เพดาน
            const otherCount = Math.max(0, holderCount - (iAmHolder ? 1 : 0));
            const otherNames = pairable ? names.filter((_, i) => ids[i] !== me) : [];
            // จำนวนคนหลังบันทึก = คนอื่น + ตัวเอง (ตัวเองนับเสมอ เพราะกำลังจะผูกหรือถืออยู่แล้ว)
            const total = otherCount + 1;

            const parts = [];
            let level = '';
            let icon = 'mdi-information-outline';

            // คอร์สรายเดือนแชร์ไม่ได้เลย — บอกตั้งแต่ตอนเลือก ไม่ใช่ตอนกดบันทึกแล้วโดนปฏิเสธ
            // ยกเว้นเด็กคนนี้ถือแพ็กเกจนี้อยู่แล้ว: backend ตรวจเฉพาะตอน "เปลี่ยนค่า" (sameAsStored)
            // การกดบันทึกโดยไม่แตะช่องคอร์สจึงผ่านเสมอ — เตือนไปก็ผิด
            if (c.coursetype === 'Monthly' && otherCount > 0 && !iAmHolder) {
                return {
                    text: otherNames.length
                        ? this.$t('courseHolders.monthlyTaken', { names: otherNames.join(', ') })
                        : this.$t('courseHolders.monthlyTakenCount', { count: otherCount }),
                    level: 'err',
                    icon: 'mdi-alert-circle-outline',
                };
            }

            if (otherCount === 0) {
                parts.push(this.$t('courseHolders.freeToUse'));
            } else {
                parts.push(otherNames.length
                    ? this.$t('courseHolders.sharedWith', { names: otherNames.join(', '), count: total })
                    : this.$t('courseHolders.sharedWithCount', { count: total }));
                // เพดานเต็มแล้ว = "คนอื่น" ครบตามเพดาน (เกณฑ์เดียวกับ backend) — คนที่พอดีเพดานยังบันทึกได้
                if (otherCount >= this.maxCourseShare) {
                    level = 'err';
                    icon = 'mdi-alert-circle-outline';
                    parts.push(this.$t('courseHolders.capReached', { max: this.maxCourseShare }));
                } else if (total >= this.maxCourseShare) {
                    // คนสุดท้ายที่ยังผูกได้ — เตือนแต่ไม่ห้าม
                    level = 'warn';
                    icon = 'mdi-alert-outline';
                    parts.push(this.$t('courseHolders.capLast', { max: this.maxCourseShare }));
                } else if (total >= this.maxCourseShare - 1) {
                    level = 'warn';
                    icon = 'mdi-alert-outline';
                }
            }

            // ครั้งคงเหลือ/วันหมดอายุ ช่วยให้เห็นว่าแพ็กเกจที่กำลังจะผูกยังใช้ได้จริงไหม
            if (c.coursetype === 'Monthly') {
                parts.push(this.$t('courseHolders.monthlyType'));
            } else if (c.remaining !== null && c.remaining !== undefined) {
                parts.push(otherCount > 0
                    ? this.$t('courseHolders.remainingShared', { n: c.remaining })
                    : this.$t('courseHolders.remaining', { n: c.remaining }));
            }
            if (c.expiredate) parts.push(this.$t('courseHolders.expires', { date: this.$formatShortDate(c.expiredate) }));

            return { text: parts.join(' · '), level, icon };
        },
        async onCourseChange() {
            this.loadingCourse = true;
            // ล้างของใบก่อนหน้าเสมอ — ถ้า fetch ล้ม ชื่อผู้ใช้ของแพ็กเกจใบเก่าจะค้างอยู่บนจอ
            this.courseHolders = null;
            this.courseEverUsed = null;
            const seq = ++this.courseFetchSeq;
            await axios
                .get(
                    this.baseURL +
                    "/getStudentCourseDetail/" + this.editedStudentItem.courserefer,
                    {
                        headers: { Authorization: `Bearer ${this.token}` },
                    }
                )
                .then((response) => {
                    //console.dir(response);
                    if (response.data.success) {
                        //console.log("getStudentCourseDetail", response.data);
                        // ตารางการใช้งานมาจาก tbooking_group จึงมีได้แม้ไม่มีแถวแพ็กเกจแล้ว — อ่านนอก if
                        if (seq !== this.courseFetchSeq) return; // มีคำขอใหม่แซงไปแล้ว ทิ้งผลนี้
                        this.CourseUsingtList = response.data.courseDetail || [];
                        this.courseHolders = response.data.holders || null;
                        this.courseEverUsed = response.data.everUsed || null;
                    } else {
                        this.$emit("onErrorHandler", this.$t("customerCourse.loadFail"));
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    if (error.response && error.response.status == 401) {
                        this.$emit("onErrorHandler", error.response.data.message);
                        this.$emit("onClickChangeState", "login");
                    } else {
                        this.$emit("onErrorHandler", error.message);
                    }
                });
            this.loadingCourse = false;
        },
        calculateAgeNewStudent() {
            this.editedStudentItem.age = this.calculateAge(new Date(this.editedStudentItem.dateofbirth)).text;
        },
        calculateAge(birthDate) {
            if (!birthDate) return { text: "", int: 0 };

            const currentDate = new Date();
            if (new Date(birthDate) > currentDate) {
                this.birthDate = null;
                this.years = null;
                this.months = null;
                this.days = null;
                alert(this.$t("common.invalidDob"));
            }

            const diffTime = currentDate - new Date(birthDate);
            const totalDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
            let years = Math.floor(totalDays / 365.25);
            let months = Math.floor((totalDays % 365.25) / 30.4375);
            return {
                text : years + " " + this.$t('table.yearAbbr') + " " + months + " " + this.$t('table.monthAbbr') + " ",
                int : years+'.'+months
            }
        },
        onShowInfoDialog(msg) {
            this.infoMsg = msg;
            this.infoDialog = true;
        },
        SQLDate(date) {
            return moment(date).format("YYYY-MM-DD");
        },
        format_date(value) {
            if (value) {
                return moment(value).format("DD/MM/YYYY");
            }
        },
        convertDate(arrObj) {
            arrObj.forEach((obj) => {
                obj.classdate = this.format_date(obj.classdate);
            });
            return arrObj;
            },
        expireDateLeft(value) {
            let result = "";
            if (value) {
                let remainingText = this.calExpireText(value);
                result = this.format_date(value) + " (" + remainingText + ")";
            }
            return result;
        },
        isExpiredDate(expdate) {
            if (!expdate) return false;
            return new Date(expdate) < new Date();
        },
        calExpireText(expdate) {
            if (!expdate) return '';
            const today = new Date();
            const expirationDate = new Date(expdate);
            let returnText = '';

            if (expirationDate < today) {
                returnText = this.$t('table.expired');
            } else {
                let years = expirationDate.getFullYear() - today.getFullYear();
                let months = expirationDate.getMonth() - today.getMonth();
                let days = expirationDate.getDate() - today.getDate();

                if (days < 0) {
                    months -= 1;
                    days += new Date(today.getFullYear(), today.getMonth() + 1, 0).getDate();
                }
                if (months < 0) {
                    years -= 1;
                    months += 12;
                }

                if (years > 0) returnText += `${years} ${this.$t('table.yearAbbr')} `;
                if (months > 0) returnText += `${months} ${this.$t('table.monthAbbr')} `;
                if (days > 0) returnText += `${days} ${this.$t('table.dayAbbr')}`;
            }
            return returnText;
        },
        async showAddNewStudent() {
            this.$emit('onLoading', true);
            await this.getCustomerCourseLookup();
            await this.getFamilyLookup();
            this.editedStudentIndex = -1;
            this.editedStudentItem = Object.assign({}, this.defaultStudentItem);
            this.courseHolders = null;   // ฟอร์มเพิ่มนักเรียนใหม่ต้องไม่ติดผู้ใช้ของคนก่อนมา
            this.courseEverUsed = null;
            this.$emit('onLoading', false);
            this.dialogStudent = true;
        },
        async showRetrieveStudent(obj) {
            if (!obj) return;
            this.$emit('onLoading', true);
            this.editedStudentIndex = 0;
            let studentDetail = await this.getStudentInfo(obj.studentid);
            if(studentDetail[0].delflag == 1) {
                this.$emit('onLoading', false);
                this.$emit('onErrorHandler', this.$t('msg.cannotEditDeleted'));
                
                return;
            }
            
            this.editedStudentItem = Object.assign({}, studentDetail[0], { level_orig: studentDetail[0].level });
            await this.getCustomerCourseLookup();
            await this.getFamilyLookup();
            if(this.editedStudentItem.dateofbirth) {
                this.editedStudentItem.dateofbirth = new Date(studentDetail[0].dateofbirth);
                this.editedStudentItem.age = this.calculateAge(studentDetail[0].dateofbirth).text;
            }
            await this.onCourseChange();
            await this.loadProfileImage();
            this.$emit('onLoading', false);
            this.dialogStudent = true;
        },
        async getStudentInfo(studentid) {
            //console.log('getStudentInfo', studentid);
            const token = this.$store.getters.getToken;
            let studentDetail = {};
            await axios
                .get(this.baseURL + "/getStudentInfo/" + studentid, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                .then((response) => {
                    //console.dir(response);
                    if (response.data.success) {
                        studentDetail = response.data.results;
                    } else {
                        this.$emit("onErrorHandler", this.$t("msg.loadFail"));
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    if (error.response && error.response.status == 401) {
                        this.$emit("onErrorHandler", error.response.data.message);
                        this.$emit("onClickChangeState", "login");
                    } else {
                        this.$emit("onErrorHandler", error.message);
                    }
                });
            return studentDetail;
        },
    },
    watch: {
        dialogStudent(val) {
            val || this.closeStudent();
        },
        dialogStudentDelete(val) {
            val || this.clickCancelDeleteStd();
        },
        // ปิด dialog อ่านอย่างเดียว → ล้างข้อมูลทิ้ง ไม่ให้ประวัติของเด็กคนก่อนค้างโผล่ตอนเปิดคนถัดไป
        dialogStudentView(val) {
            if (val) return;
            this.$nextTick(() => {
                this.viewStudent = {};
                this.historyList = [];
                this.historySummary = { total: 0, group: 0, private: 0, free: 0 };
            });
        },
        // แท็บ "ยังไม่มีผู้ปกครอง" กรองฝั่ง client — เปลี่ยนคำค้นแล้วต้องกลับหน้าแรกเสมอ
        unclaimedSearch() { this.unclaimedPage = 1; },
        search() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => {
                this.tableOptions.page = 1;
                this.getStudentList(this.currentActive);
            }, 500);
        },
        // Switching between the "all / G.A. / iStar" menus re-uses this component with a new program
        // prop → reset filters + reload from page 1.
        program() {
            this.filterStatus = "";
            this.filterGender = "";
            this.filterCourse = "";
            this.tableOptions.page = 1;
            this.getStudentList(false);
        },
    },
    computed: {
        // ปุ่มรวม = ผู้จัดการเท่านั้น · อ่าน usertype ไม่ได้ให้โชว์ไว้ แล้วให้ backend ตัดสิน (ด่านฝั่งจอห้ามปฏิเสธคนผิด)
        canMerge() {
            const t = (this.$store.getters.getUserdata || {}).usertype;
            return t === undefined || t === null || t === "" || String(t) === "0";
        },
        ...mapGetters({
            token: "getToken",
        }),
        // ── แท็บ "ยังไม่มีผู้ปกครอง" — กรอง/เรียง/แบ่งหน้าฝั่ง client (รายการมาครบทีเดียว) ──
        unclaimedHeaders() {
            return [
                { key: 'fullname', title: this.$t('table.name') },
                { key: 'family_username', title: this.$t('dup.colParkedUnder') },
                { key: 'createdate', title: this.$t('dup.colCreated') },
                { key: 'bookings', title: this.$t('dup.colBookings'), align: 'center' },
                { key: 'lastclassdate', title: this.$t('dup.colLastClass') },
                { key: 'courserefer', title: this.$t('dup.colCourse') },
                { key: 'matchname', title: this.$t('dup.colMatch') },
                { key: 'action', title: '', class: 'idt-action' },
            ];
        },
        unclaimedSortKey() {
            const s = this.unclaimedSort[0];
            return s ? `-${s.key}-${s.order}` : '';
        },
        filteredUnclaimed() {
            const q = String(this.unclaimedSearch || '').trim().toLowerCase();
            let rows = this.unclaimed;
            if (this.unclaimedFilter === 'matched') rows = rows.filter((r) => r.matches.length > 0);
            else if (this.unclaimedFilter === 'unmatched') rows = rows.filter((r) => r.matches.length === 0);
            if (q) {
                rows = rows.filter((r) => [r.fullname, r.nickname, r.studentid, r.family_username, r.courserefer,
                    ...(r.matches || []).map((m) => m.fullname)]
                    .some((v) => String(v || '').toLowerCase().includes(q)));
            }
            const sort = this.unclaimedSort[0];
            if (!sort) return rows;
            // ตัวเลขก่อน แล้วค่อยข้อความตาม locale — วันที่เป็น 'YYYY-MM-DD' อยู่แล้วจึงเรียงแบบ
            // ข้อความได้ถูกต้อง (หลักเดียวกับ IdDataGrid) · ห้ามใช้ parseFloat กับวันที่
            const val = (r) => (sort.key === 'matchname'
                ? (r.matches[0] ? r.matches[0].fullname : '')
                : (r[sort.key] == null ? '' : r[sort.key]));
            const dir = sort.order === 'desc' ? -1 : 1;
            return [...rows].sort((a, b) => {
                const x = val(a), y = val(b);
                const nx = Number(x), ny = Number(y);
                if (x !== '' && y !== '' && !Number.isNaN(nx) && !Number.isNaN(ny)) return (nx - ny) * dir;
                return String(x).localeCompare(String(y), 'th') * dir;
            });
        },
        pagedUnclaimed() {
            const start = (this.unclaimedPage - 1) * this.unclaimedPerPage;
            return this.filteredUnclaimed.slice(start, start + this.unclaimedPerPage);
        },
        // ── คำอธิบายใต้ช่องเลือกคอร์ส — บอกว่าแพ็กเกจที่เลือกมีใครใช้อยู่แล้วกี่คน ────────
        // อ่านจาก customerCourseLookup ที่โหลดไว้ก่อนเปิด dialog อยู่แล้ว จึงเป็น computed ล้วน
        // เปลี่ยนทันทีตอนเลือก ไม่ต้องยิง API (กติกา "เปิด dialog เมื่อข้อมูลครบ")
        courseDesc1() { return this.describeCourse(this.editedStudentItem.courserefer); },
        courseDesc2() { return this.describeCourse(this.editedStudentItem.courserefer2); },
        tomorrow() {
            const d = new Date();
            d.setDate(d.getDate() + 1);
            return d;
        },
        today() {
            return new Date();
        },
        formStudentTitle() {
            return this.editedStudentIndex === -1 ? this.$t('gymnasts.addStudent') : this.$t('gymnasts.editStudent')
        },
        CourseUsingHeaders() {
            return [
                { title: '#', key: 'index', width: '50px', sortable: false },
                { title: this.$t('table.name'), key: 'fullname' },
                { title: this.$t('table.date'), key: 'classdate' },
                { title: this.$t('table.time'), key: 'classtime' },
                { title: this.$t('courseUsage.bookedBy'), key: 'createby' },
                { title: this.$t('bookingMgmt.updateBy'), key: 'lastedit_by' },
            ]
        },
        StudentListHeaders() {
            return [
                { title: this.$t('table.name'), key: 'fullname' },
                { title: this.$t('table.nickname'), key: 'nickname', align: 'left' },
                { title: this.$t('table.gender'), key: 'gender', align: 'left' },
                { title: this.$t('table.age'), key: 'dateofbirth', align: 'end' },
                { title: this.$t('table.level'), key: 'level', align: 'center' },
                { title: this.$t('table.courseName'), key: 'coursename', align: 'left' },
                { title: this.$t('table.remaining'), key: 'remaining_label', align: 'center' },
                { title: this.$t('table.expireDate'), key: 'expiredate', align: 'left' },
                { title: this.$t('table.phone'), key: 'mobileno', align: 'center', sortable: false },
                // คอลัมน์ action ตามมาตรฐาน Data Grid: คลาส idt-action (กว้าง 64px จัดกลาง)
                { title: this.$t('table.view'), key: 'view', align: 'center', sortable: false, class: 'idt-action' },
                { title: this.$t('table.edit'), key: 'edit', align: 'center', sortable: false, class: 'idt-action' },
                { title: this.$t('table.history'), key: 'history', align: 'center', sortable: false, class: 'idt-action' },
                { title: this.$t('table.delete'), key: 'delete', align: 'center', sortable: false, class: 'idt-action' },
            ]
        },
        profileAvatar() {
            return this.editedStudentItem.gender == 'ชาย' ? require("@/assets/avatar/4.png") : require("@/assets/avatar/2.png");
        },
        // ---- ป้ายข้อมูลใน dialog "ดูข้อมูล + ประวัติการเรียน" (read-only) ----
        viewGenderLabel() {
            if (!this.viewStudent.gender) return '-';
            return this.viewStudent.gender == 'ชาย' ? this.$t('common.male') : this.$t('common.female');
        },
        viewCourseLabel() {
            const s = this.viewStudent;
            if (!s.courserefer) return this.$t('learningHistory.noCourse');
            return `${s.coursename || s.course_shortname || ''} (${s.courserefer})`.trim();
        },
        // Monthly = ไม่จำกัดจำนวนครั้ง (remaining เป็น NULL) จึงไม่แสดงเป็นเลข
        viewRemainingLabel() {
            const s = this.viewStudent;
            if (!s.courserefer) return '-';
            if (s.coursetype === 'Monthly') return this.$t('learningHistory.monthly');
            return `${s.remaining ?? 0} ${this.$t('common.times')}`;
        },
        // options for the course filter (label = coursename, value = courseid)
        courseFilterOptions() {
            return [{ value: '', label: this.$t('gymnasts.courseAll') }].concat(
                (this.courseOptions || []).map(c => ({ value: c.courseid, label: c.coursename || c.course_shortname || String(c.courseid) }))
            );
        },
    },
};

import { Promise } from "core-js";
const ComponentAPI = {
    baseURL: env.SERVER_URL,
    fetchDataStudent({ token, active, page, itemsPerPage, search, sortBy, program, status, gender, courseid }) {
        return new Promise((resolve) => {
            axios
                .get(this.baseURL + "/getStudentList", {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: { active, page, itemsPerPage, search, sortBy: JSON.stringify(sortBy ?? []), program, status, gender, courseid },
                })
                .then((response) => {
                    if (response.data.success) {
                        resolve({
                            success: true,
                            results: response.data.results,
                            total: response.data.total ?? response.data.results.length,
                        });
                    } else {
                        resolve({ success: true, results: [], total: 0 });
                    }
                })
                .catch((error) => {
                    resolve({ success: false, error: error });
                });
        });
    },
};
</script>
<style scoped>
.highlighted-red { color: var(--c-error); font-weight: 600; }

/* สรุปหัวตารางประวัติการเรียน — 4 ช่อง (ทั้งหมด / กลุ่ม / Private / ฟรี) */
.lh-sum { display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px; }
@media (max-width: 560px) { .lh-sum { grid-template-columns: repeat(2, 1fr); } }
.lh-tile {
  background: var(--c-surface-2); border: 1px solid var(--c-border);
  border-radius: var(--radius-md); padding: 10px 12px; text-align: center;
}
.lh-lbl { font-size: 12px; color: var(--c-text-muted); font-weight: 600; }
.lh-val { font-family: var(--font-head); font-weight: 800; font-size: 22px; color: var(--c-text-heading); line-height: 1.2; }

/* section header — pink label with accent bar */
:deep(.group-header) {
  font-family: var(--font-head); font-weight: 700; font-size: 15px;
  color: var(--c-text-heading); display: flex; align-items: center; gap: 8px; margin: 4px 0 2px;
}
:deep(.group-header)::before {
  content: ''; width: 4px; height: 18px; border-radius: 4px; background: var(--c-primary);
}

/* dialog card — white rounded surface */
:deep(.v-overlay__content > .v-card) {
  background: var(--c-surface) !important; border-radius: var(--radius-lg) !important;
  overflow: hidden !important; box-shadow: var(--shadow-lg) !important;
}

/* sticky header — pink gradient bar, white text */
.sticky-header {
  position: sticky; top: 0; z-index: 10;
  background: linear-gradient(135deg, var(--c-primary) 0%, var(--c-secondary) 100%);
  color: #fff !important; font-family: var(--font-head); font-weight: 700;
  display: flex; align-items: center; gap: 10px; padding: 16px 20px;
}
.sticky-header :deep(.mdi) { font-size: 22px; }

/* sticky footer — light surface, top divider */
.sticky-footer {
  position: sticky; bottom: 0; z-index: 10;
  background: var(--c-surface); border-top: 1px solid var(--c-border); padding: 12px 16px;
}
.sticky-footer :deep(.v-btn) { border-radius: var(--radius-md) !important; text-transform: none !important;
  font-weight: 700; letter-spacing: normal; }

.scrollable-content { max-height: 80vh; overflow-y: auto; padding: 20px !important; }

/* rounded Vuetify form controls to match the design */
:deep(.v-field) { border-radius: 14px !important; }
:deep(.v-field.v-field--variant-solo-filled) { background: var(--c-surface-2); box-shadow: none; }
:deep(.v-field--focused) { box-shadow: 0 0 0 2px var(--c-ring); }

/* toolbar (list view) */
:deep(.v-toolbar) { background: transparent !important; }
:deep(.v-toolbar-title) { font-family: var(--font-head); font-weight: 800; color: var(--c-text-heading); }
.table-search-row { padding: 8px 4px 4px; }

/* "next course" arrow — pink */
.arrow-col { display: flex; justify-content: center; align-items: center; position: relative; }
.arrow {
  width: 80%; height: 5px; position: relative; border-radius: 4px;
  background: linear-gradient(90deg, var(--c-surface-2), var(--c-primary));
  display: flex; align-items: center; justify-content: center;
}
.arrow::after {
  content: ''; position: absolute; width: 0; height: 0;
  border-top: 8px solid transparent; border-bottom: 8px solid transparent;
  border-left: 16px solid var(--c-primary); right: -7px; top: -5px;
}
.arrow-text {
  color: var(--c-primary-dark); font-weight: 700; font-size: 14px;
  position: relative; z-index: 1; top: -15px; background: transparent;
}

/* table surface passthrough (sits inside parent content-card) */
:deep(.v-card), :deep(.v-card--flat) { background: transparent !important; box-shadow: none !important; }
:deep(.v-data-table), :deep(.v-table), :deep(.v-table__wrapper),
:deep(.v-data-table__tr),
:deep(.v-table__wrapper > table > tbody > tr),
:deep(.v-table__wrapper > table > tbody > tr > td) {
  background: transparent !important; background-color: transparent !important;
}
:deep(.v-table > .v-table__wrapper > table > thead > tr > th) {
  color: var(--c-text-heading) !important; font-family: var(--font-head); font-weight: 700;
  border-bottom: 2px solid var(--c-border) !important;
}
:deep(.v-table__wrapper > table > tbody > tr:hover > td) { background: var(--c-surface-3) !important; }

/* ── กันเด็กซ้ำ: แท็บในหน้า + คิว "ยังไม่มีผู้ปกครอง" + กล่องเตือน ────────────────
   คลาสทั้งหมดขึ้นต้นด้วย .pg-tab / .unc- / .dup- ซึ่งยังไม่มีที่ไหนในระบบใช้
   (เช็คแล้วด้วย grep ทั้ง src/) จึงไม่ชนกับ istar-pages.css หรือ global-style.css
   และอยู่ใน <style scoped> ของจอนี้จอเดียว */
.pg-tabs { display: flex; gap: 8px; margin: 0 0 14px; flex-wrap: wrap; }
.pg-tab {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 8px 14px; border-radius: 999px; cursor: pointer;
  border: 1px solid var(--c-border); background: var(--c-surface-2);
  color: var(--c-text-muted); font-family: var(--font-body); font-size: 13.5px; font-weight: 600;
}
.pg-tab:hover { background: var(--c-surface-3); }
.pg-tab.on { background: var(--c-primary); border-color: var(--c-primary); color: #fff; }
.pg-tab-badge {
  min-width: 20px; padding: 0 6px; border-radius: 999px; font-size: 11.5px; line-height: 18px;
  background: rgba(0, 0, 0, .12); text-align: center;
}
.pg-tab.on .pg-tab-badge { background: rgba(255, 255, 255, .25); }

.unc-hint {
  display: flex; gap: 8px; align-items: flex-start; margin-bottom: 12px; padding: 10px 12px;
  border-radius: 10px; background: var(--c-surface-2); border: 1px solid var(--c-border);
  color: var(--c-text-muted); font-size: 13px; line-height: 1.55;
}
.unc-hint .mdi { color: var(--c-info); font-size: 18px; }
.unc-stats { display: flex; gap: 10px; flex-wrap: wrap; margin-bottom: 12px; }
.unc-stat {
  flex: 1 1 120px; padding: 10px 14px; border-radius: 12px;
  background: var(--c-surface); border: 1px solid var(--c-border); box-shadow: var(--shadow-sm);
}
.unc-stat b { display: block; font-family: var(--font-head); font-size: 20px; color: var(--c-text-heading); }
.unc-stat span { font-size: 12.5px; color: var(--c-text-muted); }
.unc-nick { color: var(--c-text-muted); margin-left: 5px; }
.unc-nofam { color: var(--c-warning); }
.unc-nomatch { color: var(--c-text-muted); font-size: 12.5px; }
/* การ์ดสรุปที่กดเป็นฟิลเตอร์ได้ (เฉพาะ "ซ้ำกับตัวจริง") */
.unc-stat.is-act { cursor: pointer; font: inherit; text-align: left; }
.unc-stat.is-act:focus-visible { outline: 2px solid var(--c-primary); outline-offset: 1px; }
.unc-stat.is-act:hover { background: var(--c-surface-2); }
.unc-stat.is-act.on { border-color: var(--c-primary); box-shadow: 0 0 0 1px var(--c-primary) inset; }
/* คอลัมน์ "ตัวจริงในระบบ" — ข้อความล้วนทั้งสองสถานะ ความสูงแถวจึงไม่ขยับ */
.unc-dup { color: var(--c-error); font-size: 13px; }
.unc-dup.weak { color: var(--c-text-muted); }
/* ปุ่มไอคอนขนาดคงที่ ใช้ทั้งสองสถานะ → ความสูงแถวเท่ากันเสมอ และ tab ถึงได้ */
.unc-act {
  width: 30px; height: 30px; display: inline-flex; align-items: center; justify-content: center;
  border: none; background: transparent; border-radius: 8px; cursor: pointer;
  color: var(--c-info); font-size: 20px; line-height: 1;
}
.unc-act:hover { background: var(--c-surface-3); }
.unc-act:focus-visible { outline: 2px solid var(--c-primary); outline-offset: 1px; }
.unc-act.warn { color: var(--c-error); }

/* กล่อง "ซ้ำ ต้องรวมประวัติ" */
.mg-warn {
  display: flex; gap: 8px; align-items: flex-start; padding: 10px 12px; border-radius: 10px;
  background: color-mix(in srgb, var(--c-error) 9%, transparent);
  border: 1px solid color-mix(in srgb, var(--c-error) 40%, transparent);
  color: var(--c-text-muted); font-size: 13px; line-height: 1.55;
}
.mg-warn .mdi { color: var(--c-error); font-size: 18px; }
.mg-pair { display: flex; gap: 12px; align-items: stretch; margin-top: 12px; }
.mg-side { flex: 1; padding: 10px 12px; border-radius: 10px; background: var(--c-surface-2); border: 1px solid var(--c-border); }
.mg-arrow { align-self: center; color: var(--c-text-muted); font-size: 22px; }
.mg-label { font-size: 11.5px; font-weight: 700; color: var(--c-text-muted); margin-bottom: 4px; }
.mg-name { font-family: var(--font-head); font-weight: 700; color: var(--c-text-heading); font-size: 14px; }
.mg-meta { font-size: 12.5px; color: var(--c-text-muted); margin-top: 2px; }
.mg-cand + .mg-cand { margin-top: 8px; padding-top: 8px; border-top: 1px dashed var(--c-border); }
.mg-do { margin-top: 6px; }
.mg-how { margin-top: 12px; font-size: 12.5px; color: var(--c-text-muted); line-height: 1.6; }
/* ป้ายความมั่นใจ — ชุดเดียวกับ DuplicateStudentDialog (คนละ component จึงต้องนิยามซ้ำ) */
.dup-conf {
  display: inline-block; margin-left: 6px; padding: 1px 8px; border-radius: 999px;
  font-size: 11.5px; font-weight: 700; color: #fff; background: var(--c-info);
}
.dup-conf.cf-veryhigh { background: var(--c-error); }
.dup-conf.cf-high { background: var(--c-warning); }

.lvh-empty { font-size: 13px; color: var(--c-text-muted); }
.lvh-row { display: flex; flex-wrap: wrap; gap: 4px 12px; align-items: baseline; padding: 6px 0; border-bottom: 1px solid var(--c-border, #f0eaee); font-size: 13px; }
.lvh-row.voided .lvh-lv, .lvh-row.voided .lvh-src { text-decoration: line-through; color: var(--c-text-muted); }
.lvh-lv { font-weight: 700; min-width: 56px; }
.lvh-by { font-size: 12px; color: var(--c-text-muted); margin-left: auto; }
</style>
